//non admin
//I've decided to do this page NOT by venue, but just a long list
import React, { useState, useEffect, useContext } from 'react'
import './FullSchedule.css'
import { Link, useParams } from 'react-router-dom'
import Button from '../components/UIElements/Button'
import ErrorModal from '../components/UIElements/ErrorModal'
import Modal from '../components/UIElements/Modal'
import { useNavigate } from 'react-router-dom'
import { AuthContext } from '../context/auth-context'
import Footer from '../components/UIElements/Footer'
import LoadingSpinner from '../components/UIElements/LoadingSpinner'

const TeamRegistrationUpdate = () => {
	console.log('inside TeamRegistrationUpdate')

	const auth = useContext(AuthContext)

	console.log('admin logged in:', auth.isLoggedIn)
	console.log('coach logged in:', auth.coachIsLoggedIn)

	const shirtSizeOptions = [
		'',
		'YS',
		'YM',
		'YL',
		'YXL',
		'S',
		'M',
		'L',
		'XL',
		'2XL',
		'3XL',
	]
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [showSuccessfulRegistrationModal, setShowSuccessfulRegistrationModal] =
		useState(false)
	const [originalHeadCoach, setOriginalHeadCoach] = useState()
	const [headCoach, setHeadCoach] = useState()
	const [originalAssistantCoaches, setOriginalAssistantCoaches] = useState()
	const [originalShipToName, setOriginalShipToName] = useState()
	const [originalShippingAddress, setOriginalShippingAddress] = useState()
	const [assistantCoaches, setAssistantCoaches] = useState()
	const [shipToName, setShipToName] = useState()
	const [shippingAddress, setShippingAddress] = useState()
	const [originalTeam, setOriginalTeam] = useState()
	const [team, setTeam] = useState()
	const [originalYear, setOriginalYear] = useState()
	const [year, setYear] = useState()
	const [originalDate, setOriginalDate] = useState()
	const [date, setDate] = useState()
	const [originalOrg, setOriginalOrg] = useState()
	const [originalDiv, setOriginalDiv] = useState()
	const [originalAbc, setOriginalAbc] = useState()
	const [org, setOrg] = useState()
	const [manualOrg, setManualOrg] = useState('')
	const [manualOrgTouched, setManualOrgTouched] = useState(false)
	const [formSubmitted, setFormSubmitted] = useState(false)
	const [originalManualOrg, setOriginalManualOrg] = useState('')
	const [div, setDiv] = useState()
	const [abc, setAbc] = useState()
	const [loadedOrgs, setLoadedOrgs] = useState()
	const [orgDropdownCreated, setOrgDropdownCreated] = useState(false)
	const [orgArray, setOrgArray] = useState([])
	//
	//
	const [name1, setName1] = useState()
	const [number1, setNumber1] = useState()
	const [BY1, setBY1] = useState()
	const [playerIsGoalie1, setPlayerIsGoalie1] = useState()
	const [playerIsTaxi1, setPlayerIsTaxi1] = useState()
	const [originalName1, setOriginalName1] = useState()
	const [originalNumber1, setOriginalNumber1] = useState()
	const [originalBY1, setOriginalBY1] = useState()
	//
	const [name2, setName2] = useState()
	const [number2, setNumber2] = useState()
	const [BY2, setBY2] = useState()
	const [playerIsGoalie2, setPlayerIsGoalie2] = useState()
	const [playerIsTaxi2, setPlayerIsTaxi2] = useState()
	const [originalName2, setOriginalName2] = useState()
	const [originalNumber2, setOriginalNumber2] = useState()
	const [originalBY2, setOriginalBY2] = useState()
	//
	const [name3, setName3] = useState()
	const [number3, setNumber3] = useState()
	const [BY3, setBY3] = useState()
	const [playerIsGoalie3, setPlayerIsGoalie3] = useState()
	const [playerIsTaxi3, setPlayerIsTaxi3] = useState()
	const [originalName3, setOriginalName3] = useState()
	const [originalNumber3, setOriginalNumber3] = useState()
	const [originalBY3, setOriginalBY3] = useState()
	//
	const [name4, setName4] = useState()
	const [number4, setNumber4] = useState()
	const [BY4, setBY4] = useState()
	const [playerIsGoalie4, setPlayerIsGoalie4] = useState()
	const [playerIsTaxi4, setPlayerIsTaxi4] = useState()
	const [originalName4, setOriginalName4] = useState()
	const [originalNumber4, setOriginalNumber4] = useState()
	const [originalBY4, setOriginalBY4] = useState()
	//
	const [name5, setName5] = useState()
	const [number5, setNumber5] = useState()
	const [BY5, setBY5] = useState()
	const [playerIsGoalie5, setPlayerIsGoalie5] = useState()
	const [playerIsTaxi5, setPlayerIsTaxi5] = useState()
	const [originalName5, setOriginalName5] = useState()
	const [originalNumber5, setOriginalNumber5] = useState()
	const [originalBY5, setOriginalBY5] = useState()
	//
	const [name6, setName6] = useState()
	const [number6, setNumber6] = useState()
	const [BY6, setBY6] = useState()
	const [playerIsGoalie6, setPlayerIsGoalie6] = useState()
	const [playerIsTaxi6, setPlayerIsTaxi6] = useState()
	const [originalName6, setOriginalName6] = useState()
	const [originalNumber6, setOriginalNumber6] = useState()
	const [originalBY6, setOriginalBY6] = useState()
	//
	const [name7, setName7] = useState()
	const [number7, setNumber7] = useState()
	const [BY7, setBY7] = useState()
	const [playerIsGoalie7, setPlayerIsGoalie7] = useState()
	const [playerIsTaxi7, setPlayerIsTaxi7] = useState()
	const [originalName7, setOriginalName7] = useState()
	const [originalNumber7, setOriginalNumber7] = useState()
	const [originalBY7, setOriginalBY7] = useState()
	//
	const [name8, setName8] = useState()
	const [number8, setNumber8] = useState()
	const [BY8, setBY8] = useState()
	const [playerIsGoalie8, setPlayerIsGoalie8] = useState()
	const [playerIsTaxi8, setPlayerIsTaxi8] = useState()
	const [originalName8, setOriginalName8] = useState()
	const [originalNumber8, setOriginalNumber8] = useState()
	const [originalBY8, setOriginalBY8] = useState()
	//
	const [name9, setName9] = useState()
	const [number9, setNumber9] = useState()
	const [BY9, setBY9] = useState()
	const [playerIsGoalie9, setPlayerIsGoalie9] = useState()
	const [playerIsTaxi9, setPlayerIsTaxi9] = useState()
	const [originalName9, setOriginalName9] = useState()
	const [originalNumber9, setOriginalNumber9] = useState()
	const [originalBY9, setOriginalBY9] = useState()
	//
	const [name10, setName10] = useState()
	const [number10, setNumber10] = useState()
	const [BY10, setBY10] = useState()
	const [playerIsGoalie10, setPlayerIsGoalie10] = useState()
	const [playerIsTaxi10, setPlayerIsTaxi10] = useState()
	const [originalName10, setOriginalName10] = useState()
	const [originalNumber10, setOriginalNumber10] = useState()
	const [originalBY10, setOriginalBY10] = useState()
	//
	const [name11, setName11] = useState()
	const [number11, setNumber11] = useState()
	const [BY11, setBY11] = useState()
	const [playerIsGoalie11, setPlayerIsGoalie11] = useState()
	const [playerIsTaxi11, setPlayerIsTaxi11] = useState()
	const [originalName11, setOriginalName11] = useState()
	const [originalNumber11, setOriginalNumber11] = useState()
	const [originalBY11, setOriginalBY11] = useState()
	//
	const [name12, setName12] = useState()
	const [number12, setNumber12] = useState()
	const [BY12, setBY12] = useState()
	const [playerIsGoalie12, setPlayerIsGoalie12] = useState()
	const [playerIsTaxi12, setPlayerIsTaxi12] = useState()
	const [originalName12, setOriginalName12] = useState()
	const [originalNumber12, setOriginalNumber12] = useState()
	const [originalBY12, setOriginalBY12] = useState()
	//
	const [name13, setName13] = useState()
	const [number13, setNumber13] = useState()
	const [BY13, setBY13] = useState()
	const [playerIsGoalie13, setPlayerIsGoalie13] = useState()
	const [playerIsTaxi13, setPlayerIsTaxi13] = useState()
	const [originalName13, setOriginalName13] = useState()
	const [originalNumber13, setOriginalNumber13] = useState()
	const [originalBY13, setOriginalBY13] = useState()
	//
	const [name14, setName14] = useState()
	const [number14, setNumber14] = useState()
	const [BY14, setBY14] = useState()
	const [playerIsGoalie14, setPlayerIsGoalie14] = useState()
	const [playerIsTaxi14, setPlayerIsTaxi14] = useState()
	const [originalName14, setOriginalName14] = useState()
	const [originalNumber14, setOriginalNumber14] = useState()
	const [originalBY14, setOriginalBY14] = useState()
	//
	const [name15, setName15] = useState()
	const [number15, setNumber15] = useState()
	const [BY15, setBY15] = useState()
	const [playerIsGoalie15, setPlayerIsGoalie15] = useState()
	const [playerIsTaxi15, setPlayerIsTaxi15] = useState()
	const [originalName15, setOriginalName15] = useState()
	const [originalNumber15, setOriginalNumber15] = useState()
	const [originalBY15, setOriginalBY15] = useState()
	//
	const [name16, setName16] = useState()
	const [number16, setNumber16] = useState()
	const [BY16, setBY16] = useState()
	const [playerIsGoalie16, setPlayerIsGoalie16] = useState()
	const [playerIsTaxi16, setPlayerIsTaxi16] = useState()
	const [originalName16, setOriginalName16] = useState()
	const [originalNumber16, setOriginalNumber16] = useState()
	const [originalBY16, setOriginalBY16] = useState()
	//
	const [name17, setName17] = useState()
	const [number17, setNumber17] = useState()
	const [BY17, setBY17] = useState()
	const [playerIsGoalie17, setPlayerIsGoalie17] = useState()
	const [playerIsTaxi17, setPlayerIsTaxi17] = useState()
	const [originalName17, setOriginalName17] = useState()
	const [originalNumber17, setOriginalNumber17] = useState()
	const [originalBY17, setOriginalBY17] = useState()
	//
	const [name18, setName18] = useState()
	const [number18, setNumber18] = useState()
	const [BY18, setBY18] = useState()
	const [playerIsGoalie18, setPlayerIsGoalie18] = useState()
	const [playerIsTaxi18, setPlayerIsTaxi18] = useState()
	const [originalName18, setOriginalName18] = useState()
	const [originalNumber18, setOriginalNumber18] = useState()
	const [originalBY18, setOriginalBY18] = useState()
	//
	const [name19, setName19] = useState()
	const [number19, setNumber19] = useState()
	const [BY19, setBY19] = useState()
	const [playerIsGoalie19, setPlayerIsGoalie19] = useState()
	const [playerIsTaxi19, setPlayerIsTaxi19] = useState()
	const [originalName19, setOriginalName19] = useState()
	const [originalNumber19, setOriginalNumber19] = useState()
	const [originalBY19, setOriginalBY19] = useState()
	//
	const [name20, setName20] = useState()
	const [number20, setNumber20] = useState()
	const [BY20, setBY20] = useState()
	const [playerIsGoalie20, setPlayerIsGoalie20] = useState()
	const [playerIsTaxi20, setPlayerIsTaxi20] = useState()
	const [originalName20, setOriginalName20] = useState()
	const [originalNumber20, setOriginalNumber20] = useState()
	const [originalBY20, setOriginalBY20] = useState()
	//
	const [name21, setName21] = useState()
	const [number21, setNumber21] = useState()
	const [BY21, setBY21] = useState()
	const [playerIsGoalie21, setPlayerIsGoalie21] = useState()
	const [playerIsTaxi21, setPlayerIsTaxi21] = useState()
	const [originalName21, setOriginalName21] = useState()
	const [originalNumber21, setOriginalNumber21] = useState()
	const [originalBY21, setOriginalBY21] = useState()
	//
	const [name22, setName22] = useState()
	const [number22, setNumber22] = useState()
	const [BY22, setBY22] = useState()
	const [playerIsGoalie22, setPlayerIsGoalie22] = useState()
	const [playerIsTaxi22, setPlayerIsTaxi22] = useState()
	const [originalName22, setOriginalName22] = useState()
	const [originalNumber22, setOriginalNumber22] = useState()
	const [originalBY22, setOriginalBY22] = useState()
	//
	const [name23, setName23] = useState()
	const [number23, setNumber23] = useState()
	const [BY23, setBY23] = useState()
	const [playerIsGoalie23, setPlayerIsGoalie23] = useState()
	const [playerIsTaxi23, setPlayerIsTaxi23] = useState()
	const [originalName23, setOriginalName23] = useState()
	const [originalNumber23, setOriginalNumber23] = useState()
	const [originalBY23, setOriginalBY23] = useState()
	//
	const [name24, setName24] = useState()
	const [number24, setNumber24] = useState()
	const [BY24, setBY24] = useState()
	const [playerIsGoalie24, setPlayerIsGoalie24] = useState()
	const [playerIsTaxi24, setPlayerIsTaxi24] = useState()
	const [originalName24, setOriginalName24] = useState()
	const [originalNumber24, setOriginalNumber24] = useState()
	const [originalBY24, setOriginalBY24] = useState()
	//
	const [name25, setName25] = useState()
	const [number25, setNumber25] = useState()
	const [BY25, setBY25] = useState()
	const [playerIsGoalie25, setPlayerIsGoalie25] = useState()
	const [playerIsTaxi25, setPlayerIsTaxi25] = useState()
	const [originalName25, setOriginalName25] = useState()
	const [originalNumber25, setOriginalNumber25] = useState()
	const [originalBY25, setOriginalBY25] = useState()
	//
	const [name26, setName26] = useState()
	const [number26, setNumber26] = useState()
	const [BY26, setBY26] = useState()
	const [playerIsGoalie26, setPlayerIsGoalie26] = useState()
	const [playerIsTaxi26, setPlayerIsTaxi26] = useState()
	const [originalName26, setOriginalName26] = useState()
	const [originalNumber26, setOriginalNumber26] = useState()
	const [originalBY26, setOriginalBY26] = useState()
	//
	const [name27, setName27] = useState()
	const [number27, setNumber27] = useState()
	const [BY27, setBY27] = useState()
	const [playerIsGoalie27, setPlayerIsGoalie27] = useState()
	const [playerIsTaxi27, setPlayerIsTaxi27] = useState()
	const [originalName27, setOriginalName27] = useState()
	const [originalNumber27, setOriginalNumber27] = useState()
	const [originalBY27, setOriginalBY27] = useState()
	//
	const [name28, setName28] = useState()
	const [number28, setNumber28] = useState()
	const [BY28, setBY28] = useState()
	const [playerIsGoalie28, setPlayerIsGoalie28] = useState()
	const [playerIsTaxi28, setPlayerIsTaxi28] = useState()
	const [originalName28, setOriginalName28] = useState()
	const [originalNumber28, setOriginalNumber28] = useState()
	const [originalBY28, setOriginalBY28] = useState()
	//
	const [name29, setName29] = useState()
	const [number29, setNumber29] = useState()
	const [BY29, setBY29] = useState()
	const [playerIsGoalie29, setPlayerIsGoalie29] = useState()
	const [playerIsTaxi29, setPlayerIsTaxi29] = useState()
	const [originalName29, setOriginalName29] = useState()
	const [originalNumber29, setOriginalNumber29] = useState()
	const [originalBY29, setOriginalBY29] = useState()
	//
	const [name30, setName30] = useState()
	const [number30, setNumber30] = useState()
	const [BY30, setBY30] = useState()
	const [playerIsGoalie30, setPlayerIsGoalie30] = useState()
	const [playerIsTaxi30, setPlayerIsTaxi30] = useState()
	const [originalName30, setOriginalName30] = useState()
	const [originalNumber30, setOriginalNumber30] = useState()
	const [originalBY30, setOriginalBY30] = useState()
	//
	//
	const [playerIsActive1, setPlayerIsActive1] = useState()
	const [playerIsActive2, setPlayerIsActive2] = useState()
	const [playerIsActive3, setPlayerIsActive3] = useState()
	const [playerIsActive4, setPlayerIsActive4] = useState()
	const [playerIsActive5, setPlayerIsActive5] = useState()
	const [playerIsActive6, setPlayerIsActive6] = useState()
	const [playerIsActive7, setPlayerIsActive7] = useState()
	const [playerIsActive8, setPlayerIsActive8] = useState()
	const [playerIsActive9, setPlayerIsActive9] = useState()
	const [playerIsActive10, setPlayerIsActive10] = useState()
	const [playerIsActive11, setPlayerIsActive11] = useState()
	const [playerIsActive12, setPlayerIsActive12] = useState()
	const [playerIsActive13, setPlayerIsActive13] = useState()
	const [playerIsActive14, setPlayerIsActive14] = useState()
	const [playerIsActive15, setPlayerIsActive15] = useState()
	const [playerIsActive16, setPlayerIsActive16] = useState()
	const [playerIsActive17, setPlayerIsActive17] = useState()
	const [playerIsActive18, setPlayerIsActive18] = useState()
	const [playerIsActive19, setPlayerIsActive19] = useState()
	const [playerIsActive20, setPlayerIsActive20] = useState()
	const [playerIsActive21, setPlayerIsActive21] = useState()
	const [playerIsActive22, setPlayerIsActive22] = useState()
	const [playerIsActive23, setPlayerIsActive23] = useState()
	const [playerIsActive24, setPlayerIsActive24] = useState()
	const [playerIsActive25, setPlayerIsActive25] = useState()
	const [playerIsActive26, setPlayerIsActive26] = useState()
	const [playerIsActive27, setPlayerIsActive27] = useState()
	const [playerIsActive28, setPlayerIsActive28] = useState()
	const [playerIsActive29, setPlayerIsActive29] = useState()
	const [playerIsActive30, setPlayerIsActive30] = useState()
	//
	const [originalTeeShirt1, setOriginalTeeShirt1] = useState()
	const [originalTeeShirt2, setOriginalTeeShirt2] = useState()
	const [originalTeeShirt3, setOriginalTeeShirt3] = useState()
	const [originalTeeShirt4, setOriginalTeeShirt4] = useState()
	const [originalTeeShirt5, setOriginalTeeShirt5] = useState()
	const [originalTeeShirt6, setOriginalTeeShirt6] = useState()
	const [originalTeeShirt7, setOriginalTeeShirt7] = useState()
	const [originalTeeShirt8, setOriginalTeeShirt8] = useState()
	const [originalTeeShirt9, setOriginalTeeShirt9] = useState()
	const [originalTeeShirt10, setOriginalTeeShirt10] = useState()
	const [originalTeeShirt11, setOriginalTeeShirt11] = useState()
	const [originalTeeShirt12, setOriginalTeeShirt12] = useState()
	const [originalTeeShirt13, setOriginalTeeShirt13] = useState()
	const [originalTeeShirt14, setOriginalTeeShirt14] = useState()
	const [originalTeeShirt15, setOriginalTeeShirt15] = useState()
	const [originalTeeShirt16, setOriginalTeeShirt16] = useState()
	const [originalTeeShirt17, setOriginalTeeShirt17] = useState()
	const [originalTeeShirt18, setOriginalTeeShirt18] = useState()
	const [originalTeeShirt19, setOriginalTeeShirt19] = useState()
	const [originalTeeShirt20, setOriginalTeeShirt20] = useState()
	const [originalTeeShirt21, setOriginalTeeShirt21] = useState()
	const [originalTeeShirt22, setOriginalTeeShirt22] = useState()
	const [originalTeeShirt23, setOriginalTeeShirt23] = useState()
	const [originalTeeShirt24, setOriginalTeeShirt24] = useState()
	const [originalTeeShirt25, setOriginalTeeShirt25] = useState()
	const [originalTeeShirt26, setOriginalTeeShirt26] = useState()
	const [originalTeeShirt27, setOriginalTeeShirt27] = useState()
	const [originalTeeShirt28, setOriginalTeeShirt28] = useState()
	const [originalTeeShirt29, setOriginalTeeShirt29] = useState()
	const [originalTeeShirt30, setOriginalTeeShirt30] = useState()
	//
	const [originalHoodie1, setOriginalHoodie1] = useState()
	const [originalHoodie2, setOriginalHoodie2] = useState()
	const [originalHoodie3, setOriginalHoodie3] = useState()
	const [originalHoodie4, setOriginalHoodie4] = useState()
	const [originalHoodie5, setOriginalHoodie5] = useState()
	const [originalHoodie6, setOriginalHoodie6] = useState()
	const [originalHoodie7, setOriginalHoodie7] = useState()
	const [originalHoodie8, setOriginalHoodie8] = useState()
	const [originalHoodie9, setOriginalHoodie9] = useState()
	const [originalHoodie10, setOriginalHoodie10] = useState()
	const [originalHoodie11, setOriginalHoodie11] = useState()
	const [originalHoodie12, setOriginalHoodie12] = useState()
	const [originalHoodie13, setOriginalHoodie13] = useState()
	const [originalHoodie14, setOriginalHoodie14] = useState()
	const [originalHoodie15, setOriginalHoodie15] = useState()
	const [originalHoodie16, setOriginalHoodie16] = useState()
	const [originalHoodie17, setOriginalHoodie17] = useState()
	const [originalHoodie18, setOriginalHoodie18] = useState()
	const [originalHoodie19, setOriginalHoodie19] = useState()
	const [originalHoodie20, setOriginalHoodie20] = useState()
	const [originalHoodie21, setOriginalHoodie21] = useState()
	const [originalHoodie22, setOriginalHoodie22] = useState()
	const [originalHoodie23, setOriginalHoodie23] = useState()
	const [originalHoodie24, setOriginalHoodie24] = useState()
	const [originalHoodie25, setOriginalHoodie25] = useState()
	const [originalHoodie26, setOriginalHoodie26] = useState()
	const [originalHoodie27, setOriginalHoodie27] = useState()
	const [originalHoodie28, setOriginalHoodie28] = useState()
	const [originalHoodie29, setOriginalHoodie29] = useState()
	const [originalHoodie30, setOriginalHoodie30] = useState()
	//
	const [teeShirt1, setTeeShirt1] = useState()
	const [teeShirt2, setTeeShirt2] = useState()
	const [teeShirt3, setTeeShirt3] = useState()
	const [teeShirt4, setTeeShirt4] = useState()
	const [teeShirt5, setTeeShirt5] = useState()
	const [teeShirt6, setTeeShirt6] = useState()
	const [teeShirt7, setTeeShirt7] = useState()
	const [teeShirt8, setTeeShirt8] = useState()
	const [teeShirt9, setTeeShirt9] = useState()
	const [teeShirt10, setTeeShirt10] = useState()

	const [teeShirt11, setTeeShirt11] = useState()
	const [teeShirt12, setTeeShirt12] = useState()
	const [teeShirt13, setTeeShirt13] = useState()
	const [teeShirt14, setTeeShirt14] = useState()
	const [teeShirt15, setTeeShirt15] = useState()
	const [teeShirt16, setTeeShirt16] = useState()
	const [teeShirt17, setTeeShirt17] = useState()
	const [teeShirt18, setTeeShirt18] = useState()
	const [teeShirt19, setTeeShirt19] = useState()
	const [teeShirt20, setTeeShirt20] = useState()

	const [teeShirt21, setTeeShirt21] = useState()
	const [teeShirt22, setTeeShirt22] = useState()
	const [teeShirt23, setTeeShirt23] = useState()
	const [teeShirt24, setTeeShirt24] = useState()
	const [teeShirt25, setTeeShirt25] = useState()
	const [teeShirt26, setTeeShirt26] = useState()
	const [teeShirt27, setTeeShirt27] = useState()
	const [teeShirt28, setTeeShirt28] = useState()
	const [teeShirt29, setTeeShirt29] = useState()
	const [teeShirt30, setTeeShirt30] = useState()
	//
	const [hoodie1, setHoodie1] = useState()
	const [hoodie2, setHoodie2] = useState()
	const [hoodie3, setHoodie3] = useState()
	const [hoodie4, setHoodie4] = useState()
	const [hoodie5, setHoodie5] = useState()
	const [hoodie6, setHoodie6] = useState()
	const [hoodie7, setHoodie7] = useState()
	const [hoodie8, setHoodie8] = useState()
	const [hoodie9, setHoodie9] = useState()
	const [hoodie10, setHoodie10] = useState()

	const [hoodie11, setHoodie11] = useState()
	const [hoodie12, setHoodie12] = useState()
	const [hoodie13, setHoodie13] = useState()
	const [hoodie14, setHoodie14] = useState()
	const [hoodie15, setHoodie15] = useState()
	const [hoodie16, setHoodie16] = useState()
	const [hoodie17, setHoodie17] = useState()
	const [hoodie18, setHoodie18] = useState()
	const [hoodie19, setHoodie19] = useState()
	const [hoodie20, setHoodie20] = useState()

	const [hoodie21, setHoodie21] = useState()
	const [hoodie22, setHoodie22] = useState()
	const [hoodie23, setHoodie23] = useState()
	const [hoodie24, setHoodie24] = useState()
	const [hoodie25, setHoodie25] = useState()
	const [hoodie26, setHoodie26] = useState()
	const [hoodie27, setHoodie27] = useState()
	const [hoodie28, setHoodie28] = useState()
	const [hoodie29, setHoodie29] = useState()
	const [hoodie30, setHoodie30] = useState()

	//
	//
	//const coachId = useParams().coachId
	//const inputTeamName = useParams().team
	//const inputYear = useParams().year
	const {
		coachId,
		orgId,
		registeredTeamId,
		team: inputTeamName,
		year: inputYear,
	} = useParams()
	//
	//
	//First thing we want to do here is go into the database and get this team information
	//admin-controller       getRegisteredTeamData
	//
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				let url

				if (registeredTeamId) {
					url =
						process.env.REACT_APP_BACKEND_URL +
						`/admin/registeredTeam/${registeredTeamId}`
				} else if (orgId) {
					url =
						process.env.REACT_APP_BACKEND_URL +
						`/admin/org/${orgId}/${encodeURIComponent(inputTeamName)}/${inputYear}`
				} else {
					url =
						process.env.REACT_APP_BACKEND_URL +
						`/admin/${coachId}/${encodeURIComponent(inputTeamName)}/${inputYear}`
				}

				console.log('✅ params:', { coachId, orgId, inputTeamName, inputYear })
				console.log('✅ fetch url:', url)

				const response = await fetch(url)
				const responseData = await response.json()

				if (!response.ok) throw new Error(responseData.message)

				console.log('responseData: ' + JSON.stringify(responseData))

				setOriginalHeadCoach(responseData.headCoach)
				setOriginalAssistantCoaches(responseData.assistantCoaches)
				setOriginalShipToName(responseData.shipToName)
				setOriginalShippingAddress(responseData.shippingAddress)
				setOriginalTeam(responseData.team)
				setOriginalOrg(responseData.org || responseData.organization)
				setOriginalManualOrg(responseData.manualOrg || '')
				setManualOrg(responseData.manualOrg || '')

				setOriginalDiv(responseData.division)
				setOriginalAbc(responseData.abc)
				setOriginalYear(responseData.year)
				setOriginalDate(responseData.date)
				//
				setOriginalName1(responseData.name1)
				setOriginalNumber1(responseData.number1)
				setOriginalBY1(responseData.BY1)
				setPlayerIsGoalie1(responseData.playerIsGoalie1)
				setPlayerIsTaxi1(responseData.playerIsTaxi1)
				//
				setOriginalName2(responseData.name2)
				setOriginalNumber2(responseData.number2)
				setOriginalBY2(responseData.BY2)
				setPlayerIsGoalie2(responseData.playerIsGoalie2)
				setPlayerIsTaxi2(responseData.playerIsTaxi2)
				//
				setOriginalName3(responseData.name3)
				setOriginalNumber3(responseData.number3)
				setOriginalBY3(responseData.BY3)
				setPlayerIsGoalie3(responseData.playerIsGoalie3)
				setPlayerIsTaxi3(responseData.playerIsTaxi3)
				//
				setOriginalName4(responseData.name4)
				setOriginalNumber4(responseData.number4)
				setOriginalBY4(responseData.BY4)
				setPlayerIsGoalie4(responseData.playerIsGoalie4)
				setPlayerIsTaxi4(responseData.playerIsTaxi4)
				//
				setOriginalName5(responseData.name5)
				setOriginalNumber5(responseData.number5)
				setOriginalBY5(responseData.BY5)
				setPlayerIsGoalie5(responseData.playerIsGoalie5)
				setPlayerIsTaxi5(responseData.playerIsTaxi5)
				//
				setOriginalName6(responseData.name6)
				setOriginalNumber6(responseData.number6)
				setOriginalBY6(responseData.BY6)
				setPlayerIsGoalie6(responseData.playerIsGoalie6)
				setPlayerIsTaxi6(responseData.playerIsTaxi6)
				//
				setOriginalName7(responseData.name7)
				setOriginalNumber7(responseData.number7)
				setOriginalBY7(responseData.BY7)
				setPlayerIsGoalie7(responseData.playerIsGoalie7)
				setPlayerIsTaxi7(responseData.playerIsTaxi7)
				//
				setOriginalName8(responseData.name8)
				setOriginalNumber8(responseData.number8)
				setOriginalBY8(responseData.BY8)
				setPlayerIsGoalie8(responseData.playerIsGoalie8)
				setPlayerIsTaxi8(responseData.playerIsTaxi8)
				//
				setOriginalName9(responseData.name9)
				setOriginalNumber9(responseData.number9)
				setOriginalBY9(responseData.BY9)
				setPlayerIsGoalie9(responseData.playerIsGoalie9)
				setPlayerIsTaxi9(responseData.playerIsTaxi9)
				//
				setOriginalName10(responseData.name10)
				setOriginalNumber10(responseData.number10)
				setOriginalBY10(responseData.BY10)
				setPlayerIsGoalie10(responseData.playerIsGoalie10)
				setPlayerIsTaxi10(responseData.playerIsTaxi10)
				//
				setOriginalName11(responseData.name11)
				setOriginalNumber11(responseData.number11)
				setOriginalBY11(responseData.BY11)
				setPlayerIsGoalie11(responseData.playerIsGoalie11)
				setPlayerIsTaxi11(responseData.playerIsTaxi11)
				//
				setOriginalName12(responseData.name12)
				setOriginalNumber12(responseData.number12)
				setOriginalBY12(responseData.BY12)
				setPlayerIsGoalie12(responseData.playerIsGoalie12)
				setPlayerIsTaxi12(responseData.playerIsTaxi12)
				//
				setOriginalName13(responseData.name13)
				setOriginalNumber13(responseData.number13)
				setOriginalBY13(responseData.BY13)
				setPlayerIsGoalie13(responseData.playerIsGoalie13)
				setPlayerIsTaxi13(responseData.playerIsTaxi13)
				//
				setOriginalName14(responseData.name14)
				setOriginalNumber14(responseData.number14)
				setOriginalBY14(responseData.BY14)
				setPlayerIsGoalie14(responseData.playerIsGoalie14)
				setPlayerIsTaxi14(responseData.playerIsTaxi14)
				//
				setOriginalName15(responseData.name15)
				setOriginalNumber15(responseData.number15)
				setOriginalBY15(responseData.BY15)
				setPlayerIsGoalie15(responseData.playerIsGoalie15)
				setPlayerIsTaxi15(responseData.playerIsTaxi15)
				//
				setOriginalName16(responseData.name16)
				setOriginalNumber16(responseData.number16)
				setOriginalBY16(responseData.BY16)
				setPlayerIsGoalie16(responseData.playerIsGoalie16)
				setPlayerIsTaxi16(responseData.playerIsTaxi16)
				//
				setOriginalName17(responseData.name17)
				setOriginalNumber17(responseData.number17)
				setOriginalBY17(responseData.BY17)
				setPlayerIsGoalie17(responseData.playerIsGoalie17)
				setPlayerIsTaxi17(responseData.playerIsTaxi17)
				//
				setOriginalName18(responseData.name18)
				setOriginalNumber18(responseData.number18)
				setOriginalBY18(responseData.BY18)
				setPlayerIsGoalie18(responseData.playerIsGoalie18)
				setPlayerIsTaxi18(responseData.playerIsTaxi18)
				//
				setOriginalName19(responseData.name19)
				setOriginalNumber19(responseData.number19)
				setOriginalBY19(responseData.BY19)
				setPlayerIsGoalie19(responseData.playerIsGoalie19)
				setPlayerIsTaxi19(responseData.playerIsTaxi19)
				//
				setOriginalName20(responseData.name20)
				setOriginalNumber20(responseData.number20)
				setOriginalBY20(responseData.BY20)
				setPlayerIsGoalie20(responseData.playerIsGoalie20)
				setPlayerIsTaxi20(responseData.playerIsTaxi20)
				//
				setOriginalName21(responseData.name21)
				setOriginalNumber21(responseData.number21)
				setOriginalBY21(responseData.BY21)
				setPlayerIsGoalie21(responseData.playerIsGoalie21)
				setPlayerIsTaxi21(responseData.playerIsTaxi21)
				//
				setOriginalName22(responseData.name22)
				setOriginalNumber22(responseData.number22)
				setOriginalBY22(responseData.BY22)
				setPlayerIsGoalie22(responseData.playerIsGoalie22)
				setPlayerIsTaxi22(responseData.playerIsTaxi22)
				//
				setOriginalName23(responseData.name23)
				setOriginalNumber23(responseData.number23)
				setOriginalBY23(responseData.BY23)
				setPlayerIsGoalie23(responseData.playerIsGoalie23)
				setPlayerIsTaxi23(responseData.playerIsTaxi23)
				//
				setOriginalName24(responseData.name24)
				setOriginalNumber24(responseData.number24)
				setOriginalBY24(responseData.BY24)
				setPlayerIsGoalie24(responseData.playerIsGoalie24)
				setPlayerIsTaxi24(responseData.playerIsTaxi24)
				//
				setOriginalName25(responseData.name25)
				setOriginalNumber25(responseData.number25)
				setOriginalBY25(responseData.BY25)
				setPlayerIsGoalie25(responseData.playerIsGoalie25)
				setPlayerIsTaxi25(responseData.playerIsTaxi25)
				//
				setOriginalName26(responseData.name26)
				setOriginalNumber26(responseData.number26)
				setOriginalBY26(responseData.BY26)
				setPlayerIsGoalie26(responseData.playerIsGoalie26)
				setPlayerIsTaxi26(responseData.playerIsTaxi26)
				//
				setOriginalName27(responseData.name27)
				setOriginalNumber27(responseData.number27)
				setOriginalBY27(responseData.BY27)
				setPlayerIsGoalie27(responseData.playerIsGoalie27)
				setPlayerIsTaxi27(responseData.playerIsTaxi27)
				//
				setOriginalName28(responseData.name28)
				setOriginalNumber28(responseData.number28)
				setOriginalBY28(responseData.BY28)
				setPlayerIsGoalie28(responseData.playerIsGoalie28)
				setPlayerIsTaxi28(responseData.playerIsTaxi28)
				//
				setOriginalName29(responseData.name29)
				setOriginalNumber29(responseData.number29)
				setOriginalBY29(responseData.BY29)
				setPlayerIsGoalie29(responseData.playerIsGoalie29)
				setPlayerIsTaxi29(responseData.playerIsTaxi29)
				//
				setOriginalName30(responseData.name30)
				setOriginalNumber30(responseData.number30)
				setOriginalBY30(responseData.BY30)
				setPlayerIsGoalie30(responseData.playerIsGoalie30)
				setPlayerIsTaxi30(responseData.playerIsTaxi30)
				//
				//
				setPlayerIsActive1(responseData.playerIsActive1)
				setPlayerIsActive2(responseData.playerIsActive2)
				setPlayerIsActive3(responseData.playerIsActive3)
				setPlayerIsActive4(responseData.playerIsActive4)
				setPlayerIsActive5(responseData.playerIsActive5)
				setPlayerIsActive6(responseData.playerIsActive6)
				setPlayerIsActive7(responseData.playerIsActive7)
				setPlayerIsActive8(responseData.playerIsActive8)
				setPlayerIsActive9(responseData.playerIsActive9)
				setPlayerIsActive10(responseData.playerIsActive10)
				setPlayerIsActive11(responseData.playerIsActive11)
				setPlayerIsActive12(responseData.playerIsActive12)
				setPlayerIsActive13(responseData.playerIsActive13)
				setPlayerIsActive14(responseData.playerIsActive14)
				setPlayerIsActive15(responseData.playerIsActive15)
				setPlayerIsActive16(responseData.playerIsActive16)
				setPlayerIsActive17(responseData.playerIsActive17)
				setPlayerIsActive18(responseData.playerIsActive18)
				setPlayerIsActive19(responseData.playerIsActive19)
				setPlayerIsActive20(responseData.playerIsActive20)
				setPlayerIsActive21(responseData.playerIsActive21)
				setPlayerIsActive22(responseData.playerIsActive22)
				setPlayerIsActive23(responseData.playerIsActive23)
				setPlayerIsActive24(responseData.playerIsActive24)
				setPlayerIsActive25(responseData.playerIsActive25)
				setPlayerIsActive26(responseData.playerIsActive26)
				setPlayerIsActive27(responseData.playerIsActive27)
				setPlayerIsActive28(responseData.playerIsActive28)
				setPlayerIsActive29(responseData.playerIsActive29)
				setPlayerIsActive30(responseData.playerIsActive30)
				//
				setOriginalTeeShirt1(responseData.teeShirt1)
				setOriginalTeeShirt2(responseData.teeShirt2)
				setOriginalTeeShirt3(responseData.teeShirt3)
				setOriginalTeeShirt4(responseData.teeShirt4)
				setOriginalTeeShirt5(responseData.teeShirt5)
				setOriginalTeeShirt6(responseData.teeShirt6)
				setOriginalTeeShirt7(responseData.teeShirt7)
				setOriginalTeeShirt8(responseData.teeShirt8)
				setOriginalTeeShirt9(responseData.teeShirt9)
				setOriginalTeeShirt10(responseData.teeShirt10)

				setOriginalTeeShirt11(responseData.teeShirt11)
				setOriginalTeeShirt12(responseData.teeShirt12)
				setOriginalTeeShirt13(responseData.teeShirt13)
				setOriginalTeeShirt14(responseData.teeShirt14)
				setOriginalTeeShirt15(responseData.teeShirt15)
				setOriginalTeeShirt16(responseData.teeShirt16)
				setOriginalTeeShirt17(responseData.teeShirt17)
				setOriginalTeeShirt18(responseData.teeShirt18)
				setOriginalTeeShirt19(responseData.teeShirt19)
				setOriginalTeeShirt20(responseData.teeShirt20)

				setOriginalTeeShirt21(responseData.teeShirt21)
				setOriginalTeeShirt22(responseData.teeShirt22)
				setOriginalTeeShirt23(responseData.teeShirt23)
				setOriginalTeeShirt24(responseData.teeShirt24)
				setOriginalTeeShirt25(responseData.teeShirt25)
				setOriginalTeeShirt26(responseData.teeShirt26)
				setOriginalTeeShirt27(responseData.teeShirt27)
				setOriginalTeeShirt28(responseData.teeShirt28)
				setOriginalTeeShirt29(responseData.teeShirt29)
				setOriginalTeeShirt30(responseData.teeShirt30)
				//
				setOriginalHoodie1(responseData.hoodie1)
				setOriginalHoodie2(responseData.hoodie2)
				setOriginalHoodie3(responseData.hoodie3)
				setOriginalHoodie4(responseData.hoodie4)
				setOriginalHoodie5(responseData.hoodie5)
				setOriginalHoodie6(responseData.hoodie6)
				setOriginalHoodie7(responseData.hoodie7)
				setOriginalHoodie8(responseData.hoodie8)
				setOriginalHoodie9(responseData.hoodie9)
				setOriginalHoodie10(responseData.hoodie10)

				setOriginalHoodie11(responseData.hoodie11)
				setOriginalHoodie12(responseData.hoodie12)
				setOriginalHoodie13(responseData.hoodie13)
				setOriginalHoodie14(responseData.hoodie14)
				setOriginalHoodie15(responseData.hoodie15)
				setOriginalHoodie16(responseData.hoodie16)
				setOriginalHoodie17(responseData.hoodie17)
				setOriginalHoodie18(responseData.hoodie18)
				setOriginalHoodie19(responseData.hoodie19)
				setOriginalHoodie20(responseData.hoodie20)

				setOriginalHoodie21(responseData.hoodie21)
				setOriginalHoodie22(responseData.hoodie22)
				setOriginalHoodie23(responseData.hoodie23)
				setOriginalHoodie24(responseData.hoodie24)
				setOriginalHoodie25(responseData.hoodie25)
				setOriginalHoodie26(responseData.hoodie26)
				setOriginalHoodie27(responseData.hoodie27)
				setOriginalHoodie28(responseData.hoodie28)
				setOriginalHoodie29(responseData.hoodie29)
				setOriginalHoodie30(responseData.hoodie30)
				//
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [])
	//
	//
	//
	//
	//Next, lets call the backend to get all the organizations for our dropdown
	//     allOrgs
	useEffect(() => {
		console.log('useEffect')
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/allOrgs',
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				//console.log('responseData: ' + JSON.stringify(responseData))
				setLoadedOrgs(responseData.allOrgs)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			//
			setIsLoading(false)
		}
		sendRequest()
	}, [])
	//
	//
	//This creates an array from the loadedOrgs.  It will be our 'Organization' dropdown:
	if (loadedOrgs && !isLoading && !orgDropdownCreated) {
		const innerOrgArray = []
		loadedOrgs.forEach((org) => {
			const orgDisplay = org.orgName
			innerOrgArray.push(orgDisplay)
		})
		//NEW  This was added for leagues that have divisions
		let uniqueArray = []
		const duplicateFilter = innerOrgArray.filter((element) => {
			if (!uniqueArray.includes(element)) {
				uniqueArray.push(element)

				return true
			}
			return false
		})
		//end NEW
		setOrgArray(duplicateFilter)
		setOrgDropdownCreated(true)
	}
	//
	//
	//
	//
	//
	//
	let selectedOrg
	//
	const getHeadCoach = (event) => {
		setHeadCoach(event.target.value)
	}
	const getAssistantCoaches = (event) => {
		setAssistantCoaches(event.target.value)
	}
	const getShipToName = (event) => {
		setShipToName(event.target.value)
	}
	const getShippingAddress = (event) => {
		setShippingAddress(event.target.value)
	}
	const getTeam = (event) => {
		setTeam(event.target.value)
	}
	const getOrg = (event) => {
		const selectedValue = event.target.value
		selectedOrg = loadedOrgs[selectedValue].orgName
		console.log('selectedOrg: ' + selectedOrg)
		setOrg(selectedOrg)

		if (
			selectedOrg !== 'Non PABHA Pennsylvania Team' &&
			selectedOrg !== 'Out of State Teams'
		) {
			setManualOrg('')
			setManualOrgTouched(false)
		}
	}
	const getManualOrg = (event) => {
		setManualOrg(event.target.value)
	}
	const getDiv = (event) => {
		const selectedDiv = event.target.value
		setDiv(selectedDiv)
	}
	const getAbc = (event) => {
		const selectedAbc = event.target.value
		setAbc(selectedAbc)
	}
	const getYear = (event) => {
		setYear(event.target.value)
	}
	const getDate = (event) => {
		setDate(event.target.value)
	}
	//*************************************************** */
	//  Player 1
	//*************************************************** */
	const getName1 = (event) => {
		setName1(event.target.value)
	}
	const getNumber1 = (event) => {
		setNumber1(event.target.value)
	}
	const getBY1 = (event) => {
		setBY1(event.target.value)
	}
	const togglePlayerIsGoalieCheckbox1 = (e) => {
		if (playerIsGoalie1) {
			setPlayerIsGoalie1(false)
		}
		if (!playerIsGoalie1) {
			setPlayerIsGoalie1(true)
		}
	}
	const togglePlayerIsTaxiCheckbox1 = (e) => {
		if (playerIsTaxi1) {
			setPlayerIsTaxi1(false)
		}
		if (!playerIsTaxi1) {
			setPlayerIsTaxi1(true)
		}
	}
	const togglePlayerIsActiveCheckbox1 = (e) => {
		if (playerIsActive1) {
			setPlayerIsActive1(false)
		}
		if (!playerIsActive1) {
			setPlayerIsActive1(true)
		}
	}
	//*************************************************** */
	//  Player 2
	//*************************************************** */
	const getName2 = (event) => {
		console.log('inside getName2 ' + event.target.value)
		setName2(event.target.value)
	}
	const getNumber2 = (event) => {
		setNumber2(event.target.value)
	}
	const getBY2 = (event) => {
		setBY2(event.target.value)
	}
	const togglePlayerIsGoalieCheckbox2 = (e) => {
		if (playerIsGoalie2) {
			setPlayerIsGoalie2(false)
		}
		if (!playerIsGoalie2) {
			setPlayerIsGoalie2(true)
		}
	}
	const togglePlayerIsTaxiCheckbox2 = (e) => {
		if (playerIsTaxi2) {
			setPlayerIsTaxi2(false)
		}
		if (!playerIsTaxi2) {
			setPlayerIsTaxi2(true)
		}
	}
	const togglePlayerIsActiveCheckbox2 = (e) => {
		if (playerIsActive2) {
			setPlayerIsActive2(false)
		}
		if (!playerIsActive2) {
			setPlayerIsActive2(true)
		}
	}
	//*************************************************** */
	//  Player 3
	//*************************************************** */
	const getName3 = (event) => {
		setName3(event.target.value)
	}
	const getNumber3 = (event) => {
		setNumber3(event.target.value)
	}
	const getBY3 = (event) => {
		setBY3(event.target.value)
	}
	const togglePlayerIsGoalieCheckbox3 = (e) => {
		if (playerIsGoalie3) {
			setPlayerIsGoalie3(false)
		}
		if (!playerIsGoalie3) {
			setPlayerIsGoalie3(true)
		}
	}
	const togglePlayerIsTaxiCheckbox3 = (e) => {
		if (playerIsTaxi3) {
			setPlayerIsTaxi3(false)
		}
		if (!playerIsTaxi3) {
			setPlayerIsTaxi3(true)
		}
	}
	const togglePlayerIsActiveCheckbox3 = (e) => {
		if (playerIsActive3) {
			setPlayerIsActive3(false)
		}
		if (!playerIsActive3) {
			setPlayerIsActive3(true)
		}
	}
	//*************************************************** */
	//  Player 4
	//*************************************************** */
	const getName4 = (event) => {
		setName4(event.target.value)
	}
	const getNumber4 = (event) => {
		setNumber4(event.target.value)
	}
	const getBY4 = (event) => {
		setBY4(event.target.value)
	}
	const togglePlayerIsGoalieCheckbox4 = (e) => {
		if (playerIsGoalie4) {
			setPlayerIsGoalie4(false)
		}
		if (!playerIsGoalie4) {
			setPlayerIsGoalie4(true)
		}
	}
	const togglePlayerIsTaxiCheckbox4 = (e) => {
		if (playerIsTaxi4) {
			setPlayerIsTaxi4(false)
		}
		if (!playerIsTaxi4) {
			setPlayerIsTaxi4(true)
		}
	}
	const togglePlayerIsActiveCheckbox4 = (e) => {
		if (playerIsActive4) {
			setPlayerIsActive4(false)
		}
		if (!playerIsActive4) {
			setPlayerIsActive4(true)
		}
	}
	//*************************************************** */
	//  Player 5
	//*************************************************** */
	const getName5 = (event) => {
		setName5(event.target.value)
	}
	const getNumber5 = (event) => {
		setNumber5(event.target.value)
	}
	const getBY5 = (event) => {
		setBY5(event.target.value)
	}
	const togglePlayerIsGoalieCheckbox5 = (e) => {
		if (playerIsGoalie5) {
			setPlayerIsGoalie5(false)
		}
		if (!playerIsGoalie5) {
			setPlayerIsGoalie5(true)
		}
	}
	const togglePlayerIsTaxiCheckbox5 = (e) => {
		if (playerIsTaxi5) {
			setPlayerIsTaxi5(false)
		}
		if (!playerIsTaxi5) {
			setPlayerIsTaxi5(true)
		}
	}
	const togglePlayerIsActiveCheckbox5 = (e) => {
		if (playerIsActive5) {
			setPlayerIsActive5(false)
		}
		if (!playerIsActive5) {
			setPlayerIsActive5(true)
		}
	}
	//*************************************************** */
	//  Player 6
	//*************************************************** */
	const getName6 = (event) => {
		setName6(event.target.value)
	}
	const getNumber6 = (event) => {
		setNumber6(event.target.value)
	}
	const getBY6 = (event) => {
		setBY6(event.target.value)
	}
	const togglePlayerIsGoalieCheckbox6 = (e) => {
		if (playerIsGoalie6) {
			setPlayerIsGoalie6(false)
		}
		if (!playerIsGoalie6) {
			setPlayerIsGoalie6(true)
		}
	}
	const togglePlayerIsTaxiCheckbox6 = (e) => {
		if (playerIsTaxi6) {
			setPlayerIsTaxi6(false)
		}
		if (!playerIsTaxi6) {
			setPlayerIsTaxi6(true)
		}
	}
	const togglePlayerIsActiveCheckbox6 = (e) => {
		if (playerIsActive6) {
			setPlayerIsActive6(false)
		}
		if (!playerIsActive6) {
			setPlayerIsActive6(true)
		}
	}
	//*************************************************** */
	//  Player 7
	//*************************************************** */
	const getName7 = (event) => {
		setName7(event.target.value)
	}
	const getNumber7 = (event) => {
		setNumber7(event.target.value)
	}
	const getBY7 = (event) => {
		setBY7(event.target.value)
	}
	const togglePlayerIsGoalieCheckbox7 = (e) => {
		if (playerIsGoalie7) {
			setPlayerIsGoalie7(false)
		}
		if (!playerIsGoalie7) {
			setPlayerIsGoalie7(true)
		}
	}
	const togglePlayerIsTaxiCheckbox7 = (e) => {
		if (playerIsTaxi7) {
			setPlayerIsTaxi7(false)
		}
		if (!playerIsTaxi7) {
			setPlayerIsTaxi7(true)
		}
	}
	const togglePlayerIsActiveCheckbox7 = (e) => {
		if (playerIsActive7) {
			setPlayerIsActive7(false)
		}
		if (!playerIsActive7) {
			setPlayerIsActive7(true)
		}
	}
	//*************************************************** */
	//  Player 8
	//*************************************************** */
	const getName8 = (event) => {
		setName8(event.target.value)
	}
	const getNumber8 = (event) => {
		setNumber8(event.target.value)
	}
	const getBY8 = (event) => {
		setBY8(event.target.value)
	}
	const togglePlayerIsGoalieCheckbox8 = (e) => {
		if (playerIsGoalie8) {
			setPlayerIsGoalie8(false)
		}
		if (!playerIsGoalie8) {
			setPlayerIsGoalie8(true)
		}
	}
	const togglePlayerIsTaxiCheckbox8 = (e) => {
		if (playerIsTaxi8) {
			setPlayerIsTaxi8(false)
		}
		if (!playerIsTaxi8) {
			setPlayerIsTaxi8(true)
		}
	}
	const togglePlayerIsActiveCheckbox8 = (e) => {
		if (playerIsActive8) {
			setPlayerIsActive8(false)
		}
		if (!playerIsActive8) {
			setPlayerIsActive8(true)
		}
	}
	//*************************************************** */
	//  Player 9
	//*************************************************** */
	const getName9 = (event) => {
		setName9(event.target.value)
	}
	const getNumber9 = (event) => {
		setNumber9(event.target.value)
	}
	const getBY9 = (event) => {
		setBY9(event.target.value)
	}
	const togglePlayerIsGoalieCheckbox9 = (e) => {
		if (playerIsGoalie9) {
			setPlayerIsGoalie9(false)
		}
		if (!playerIsGoalie9) {
			setPlayerIsGoalie9(true)
		}
	}
	const togglePlayerIsTaxiCheckbox9 = (e) => {
		if (playerIsTaxi9) {
			setPlayerIsTaxi9(false)
		}
		if (!playerIsTaxi9) {
			setPlayerIsTaxi9(true)
		}
	}
	const togglePlayerIsActiveCheckbox9 = (e) => {
		if (playerIsActive9) {
			setPlayerIsActive9(false)
		}
		if (!playerIsActive9) {
			setPlayerIsActive9(true)
		}
	}
	//*************************************************** */
	//  Player 10
	//*************************************************** */
	const getName10 = (event) => {
		setName10(event.target.value)
	}
	const getNumber10 = (event) => {
		setNumber10(event.target.value)
	}
	const getBY10 = (event) => {
		setBY10(event.target.value)
	}
	const togglePlayerIsGoalieCheckbox10 = (e) => {
		if (playerIsGoalie10) {
			setPlayerIsGoalie10(false)
		}
		if (!playerIsGoalie10) {
			setPlayerIsGoalie10(true)
		}
	}
	const togglePlayerIsTaxiCheckbox10 = (e) => {
		if (playerIsTaxi10) {
			setPlayerIsTaxi10(false)
		}
		if (!playerIsTaxi10) {
			setPlayerIsTaxi10(true)
		}
	}
	const togglePlayerIsActiveCheckbox10 = (e) => {
		if (playerIsActive10) {
			setPlayerIsActive10(false)
		}
		if (!playerIsActive10) {
			setPlayerIsActive10(true)
		}
	}
	//*************************************************** */
	//  Player 11
	//*************************************************** */
	const getName11 = (event) => {
		setName11(event.target.value)
	}
	const getNumber11 = (event) => {
		setNumber11(event.target.value)
	}
	const getBY11 = (event) => {
		setBY11(event.target.value)
	}
	const togglePlayerIsGoalieCheckbox11 = (e) => {
		if (playerIsGoalie11) {
			setPlayerIsGoalie11(false)
		}
		if (!playerIsGoalie11) {
			setPlayerIsGoalie11(true)
		}
	}
	const togglePlayerIsTaxiCheckbox11 = (e) => {
		if (playerIsTaxi11) {
			setPlayerIsTaxi11(false)
		}
		if (!playerIsTaxi11) {
			setPlayerIsTaxi11(true)
		}
	}
	const togglePlayerIsActiveCheckbox11 = (e) => {
		if (playerIsActive11) {
			setPlayerIsActive11(false)
		}
		if (!playerIsActive11) {
			setPlayerIsActive11(true)
		}
	}
	//*************************************************** */
	//  Player 12
	//*************************************************** */
	const getName12 = (event) => {
		setName12(event.target.value)
	}
	const getNumber12 = (event) => {
		setNumber12(event.target.value)
	}
	const getBY12 = (event) => {
		setBY12(event.target.value)
	}
	const togglePlayerIsGoalieCheckbox12 = (e) => {
		if (playerIsGoalie12) {
			setPlayerIsGoalie12(false)
		}
		if (!playerIsGoalie12) {
			setPlayerIsGoalie12(true)
		}
	}
	const togglePlayerIsTaxiCheckbox12 = (e) => {
		if (playerIsTaxi12) {
			setPlayerIsTaxi12(false)
		}
		if (!playerIsTaxi12) {
			setPlayerIsTaxi12(true)
		}
	}
	const togglePlayerIsActiveCheckbox12 = (e) => {
		if (playerIsActive12) {
			setPlayerIsActive12(false)
		}
		if (!playerIsActive12) {
			setPlayerIsActive12(true)
		}
	}
	//*************************************************** */
	//  Player 13
	//*************************************************** */
	const getName13 = (event) => {
		setName13(event.target.value)
	}
	const getNumber13 = (event) => {
		setNumber13(event.target.value)
	}
	const getBY13 = (event) => {
		setBY13(event.target.value)
	}
	const togglePlayerIsGoalieCheckbox13 = (e) => {
		if (playerIsGoalie13) {
			setPlayerIsGoalie13(false)
		}
		if (!playerIsGoalie13) {
			setPlayerIsGoalie13(true)
		}
	}
	const togglePlayerIsTaxiCheckbox13 = (e) => {
		if (playerIsTaxi13) {
			setPlayerIsTaxi13(false)
		}
		if (!playerIsTaxi13) {
			setPlayerIsTaxi13(true)
		}
	}
	const togglePlayerIsActiveCheckbox13 = (e) => {
		if (playerIsActive13) {
			setPlayerIsActive13(false)
		}
		if (!playerIsActive13) {
			setPlayerIsActive13(true)
		}
	}
	//*************************************************** */
	//  Player 4
	//*************************************************** */
	const getName14 = (event) => {
		setName14(event.target.value)
	}
	const getNumber14 = (event) => {
		setNumber14(event.target.value)
	}
	const getBY14 = (event) => {
		setBY14(event.target.value)
	}
	const togglePlayerIsGoalieCheckbox14 = (e) => {
		if (playerIsGoalie14) {
			setPlayerIsGoalie14(false)
		}
		if (!playerIsGoalie14) {
			setPlayerIsGoalie14(true)
		}
	}
	const togglePlayerIsTaxiCheckbox14 = (e) => {
		if (playerIsTaxi14) {
			setPlayerIsTaxi14(false)
		}
		if (!playerIsTaxi14) {
			setPlayerIsTaxi14(true)
		}
	}
	const togglePlayerIsActiveCheckbox14 = (e) => {
		if (playerIsActive14) {
			setPlayerIsActive14(false)
		}
		if (!playerIsActive14) {
			setPlayerIsActive14(true)
		}
	}
	//*************************************************** */
	//  Player 15
	//*************************************************** */
	const getName15 = (event) => {
		setName15(event.target.value)
	}
	const getNumber15 = (event) => {
		setNumber15(event.target.value)
	}
	const getBY15 = (event) => {
		setBY15(event.target.value)
	}
	const togglePlayerIsGoalieCheckbox15 = (e) => {
		if (playerIsGoalie15) {
			setPlayerIsGoalie15(false)
		}
		if (!playerIsGoalie15) {
			setPlayerIsGoalie15(true)
		}
	}
	const togglePlayerIsTaxiCheckbox15 = (e) => {
		if (playerIsTaxi15) {
			setPlayerIsTaxi15(false)
		}
		if (!playerIsTaxi15) {
			setPlayerIsTaxi15(true)
		}
	}
	const togglePlayerIsActiveCheckbox15 = (e) => {
		if (playerIsActive15) {
			setPlayerIsActive15(false)
		}
		if (!playerIsActive15) {
			setPlayerIsActive15(true)
		}
	}
	//*************************************************** */
	//  Player 16
	//*************************************************** */
	const getName16 = (event) => {
		setName16(event.target.value)
	}
	const getNumber16 = (event) => {
		setNumber16(event.target.value)
	}
	const getBY16 = (event) => {
		setBY16(event.target.value)
	}
	const togglePlayerIsGoalieCheckbox16 = (e) => {
		if (playerIsGoalie16) {
			setPlayerIsGoalie16(false)
		}
		if (!playerIsGoalie16) {
			setPlayerIsGoalie16(true)
		}
	}
	const togglePlayerIsTaxiCheckbox16 = (e) => {
		if (playerIsTaxi16) {
			setPlayerIsTaxi16(false)
		}
		if (!playerIsTaxi16) {
			setPlayerIsTaxi16(true)
		}
	}
	const togglePlayerIsActiveCheckbox16 = (e) => {
		if (playerIsActive16) {
			setPlayerIsActive16(false)
		}
		if (!playerIsActive16) {
			setPlayerIsActive16(true)
		}
	}
	//*************************************************** */
	//  Player 17
	//*************************************************** */
	const getName17 = (event) => {
		setName17(event.target.value)
	}
	const getNumber17 = (event) => {
		setNumber17(event.target.value)
	}
	const getBY17 = (event) => {
		setBY17(event.target.value)
	}
	const togglePlayerIsGoalieCheckbox17 = (e) => {
		if (playerIsGoalie17) {
			setPlayerIsGoalie17(false)
		}
		if (!playerIsGoalie17) {
			setPlayerIsGoalie17(true)
		}
	}
	const togglePlayerIsTaxiCheckbox17 = (e) => {
		if (playerIsTaxi17) {
			setPlayerIsTaxi17(false)
		}
		if (!playerIsTaxi17) {
			setPlayerIsTaxi17(true)
		}
	}
	const togglePlayerIsActiveCheckbox17 = (e) => {
		if (playerIsActive17) {
			setPlayerIsActive17(false)
		}
		if (!playerIsActive17) {
			setPlayerIsActive17(true)
		}
	}
	//*************************************************** */
	//  Player 18
	//*************************************************** */
	const getName18 = (event) => {
		setName18(event.target.value)
	}
	const getNumber18 = (event) => {
		setNumber18(event.target.value)
	}
	const getBY18 = (event) => {
		setBY18(event.target.value)
	}
	const togglePlayerIsGoalieCheckbox18 = (e) => {
		if (playerIsGoalie18) {
			setPlayerIsGoalie18(false)
		}
		if (!playerIsGoalie18) {
			setPlayerIsGoalie18(true)
		}
	}
	const togglePlayerIsTaxiCheckbox18 = (e) => {
		if (playerIsTaxi18) {
			setPlayerIsTaxi18(false)
		}
		if (!playerIsTaxi18) {
			setPlayerIsTaxi18(true)
		}
	}
	const togglePlayerIsActiveCheckbox18 = (e) => {
		if (playerIsActive18) {
			setPlayerIsActive18(false)
		}
		if (!playerIsActive18) {
			setPlayerIsActive18(true)
		}
	}
	//*************************************************** */
	//  Player 19
	//*************************************************** */
	const getName19 = (event) => {
		setName19(event.target.value)
	}
	const getNumber19 = (event) => {
		setNumber19(event.target.value)
	}
	const getBY19 = (event) => {
		setBY19(event.target.value)
	}
	const togglePlayerIsGoalieCheckbox19 = (e) => {
		if (playerIsGoalie19) {
			setPlayerIsGoalie19(false)
		}
		if (!playerIsGoalie19) {
			setPlayerIsGoalie19(true)
		}
	}
	const togglePlayerIsTaxiCheckbox19 = (e) => {
		if (playerIsTaxi19) {
			setPlayerIsTaxi19(false)
		}
		if (!playerIsTaxi19) {
			setPlayerIsTaxi19(true)
		}
	}
	const togglePlayerIsActiveCheckbox19 = (e) => {
		if (playerIsActive19) {
			setPlayerIsActive19(false)
		}
		if (!playerIsActive19) {
			setPlayerIsActive19(true)
		}
	}
	//*************************************************** */
	//  Player 20
	//*************************************************** */
	const getName20 = (event) => {
		setName20(event.target.value)
	}
	const getNumber20 = (event) => {
		setNumber20(event.target.value)
	}
	const getBY20 = (event) => {
		setBY20(event.target.value)
	}
	const togglePlayerIsGoalieCheckbox20 = (e) => {
		if (playerIsGoalie20) {
			setPlayerIsGoalie20(false)
		}
		if (!playerIsGoalie20) {
			setPlayerIsGoalie20(true)
		}
	}
	const togglePlayerIsTaxiCheckbox20 = (e) => {
		if (playerIsTaxi20) {
			setPlayerIsTaxi20(false)
		}
		if (!playerIsTaxi20) {
			setPlayerIsTaxi20(true)
		}
	}
	const togglePlayerIsActiveCheckbox20 = (e) => {
		if (playerIsActive20) {
			setPlayerIsActive20(false)
		}
		if (!playerIsActive20) {
			setPlayerIsActive20(true)
		}
	}
	//*************************************************** */
	//  Player 21
	//*************************************************** */
	const getName21 = (event) => {
		setName21(event.target.value)
	}
	const getNumber21 = (event) => {
		setNumber21(event.target.value)
	}
	const getBY21 = (event) => {
		setBY21(event.target.value)
	}
	const togglePlayerIsGoalieCheckbox21 = (e) => {
		if (playerIsGoalie21) {
			setPlayerIsGoalie21(false)
		}
		if (!playerIsGoalie21) {
			setPlayerIsGoalie21(true)
		}
	}
	const togglePlayerIsTaxiCheckbox21 = (e) => {
		if (playerIsTaxi21) {
			setPlayerIsTaxi21(false)
		}
		if (!playerIsTaxi21) {
			setPlayerIsTaxi21(true)
		}
	}
	const togglePlayerIsActiveCheckbox21 = (e) => {
		if (playerIsActive21) {
			setPlayerIsActive21(false)
		}
		if (!playerIsActive21) {
			setPlayerIsActive21(true)
		}
	}
	//*************************************************** */
	//  Player 22
	//*************************************************** */
	const getName22 = (event) => {
		setName22(event.target.value)
	}
	const getNumber22 = (event) => {
		setNumber22(event.target.value)
	}
	const getBY22 = (event) => {
		setBY22(event.target.value)
	}
	const togglePlayerIsGoalieCheckbox22 = (e) => {
		if (playerIsGoalie22) {
			setPlayerIsGoalie22(false)
		}
		if (!playerIsGoalie22) {
			setPlayerIsGoalie22(true)
		}
	}
	const togglePlayerIsTaxiCheckbox22 = (e) => {
		if (playerIsTaxi22) {
			setPlayerIsTaxi22(false)
		}
		if (!playerIsTaxi22) {
			setPlayerIsTaxi22(true)
		}
	}
	const togglePlayerIsActiveCheckbox22 = (e) => {
		if (playerIsActive22) {
			setPlayerIsActive22(false)
		}
		if (!playerIsActive22) {
			setPlayerIsActive22(true)
		}
	}
	//*************************************************** */
	//  Player 23
	//*************************************************** */
	const getName23 = (event) => {
		setName23(event.target.value)
	}
	const getNumber23 = (event) => {
		setNumber23(event.target.value)
	}
	const getBY23 = (event) => {
		setBY23(event.target.value)
	}
	const togglePlayerIsGoalieCheckbox23 = (e) => {
		if (playerIsGoalie23) {
			setPlayerIsGoalie23(false)
		}
		if (!playerIsGoalie23) {
			setPlayerIsGoalie23(true)
		}
	}
	const togglePlayerIsTaxiCheckbox23 = (e) => {
		if (playerIsTaxi23) {
			setPlayerIsTaxi23(false)
		}
		if (!playerIsTaxi23) {
			setPlayerIsTaxi23(true)
		}
	}
	const togglePlayerIsActiveCheckbox23 = (e) => {
		if (playerIsActive23) {
			setPlayerIsActive23(false)
		}
		if (!playerIsActive23) {
			setPlayerIsActive23(true)
		}
	}
	//*************************************************** */
	//  Player 24
	//*************************************************** */
	const getName24 = (event) => {
		setName24(event.target.value)
	}
	const getNumber24 = (event) => {
		setNumber24(event.target.value)
	}
	const getBY24 = (event) => {
		setBY24(event.target.value)
	}
	const togglePlayerIsGoalieCheckbox24 = (e) => {
		if (playerIsGoalie24) {
			setPlayerIsGoalie24(false)
		}
		if (!playerIsGoalie24) {
			setPlayerIsGoalie24(true)
		}
	}
	const togglePlayerIsTaxiCheckbox24 = (e) => {
		if (playerIsTaxi24) {
			setPlayerIsTaxi24(false)
		}
		if (!playerIsTaxi24) {
			setPlayerIsTaxi24(true)
		}
	}
	const togglePlayerIsActiveCheckbox24 = (e) => {
		if (playerIsActive24) {
			setPlayerIsActive24(false)
		}
		if (!playerIsActive24) {
			setPlayerIsActive24(true)
		}
	}
	//*************************************************** */
	//  Player 25
	//*************************************************** */
	const getName25 = (event) => {
		setName25(event.target.value)
	}
	const getNumber25 = (event) => {
		setNumber25(event.target.value)
	}
	const getBY25 = (event) => {
		setBY25(event.target.value)
	}
	const togglePlayerIsGoalieCheckbox25 = (e) => {
		if (playerIsGoalie25) {
			setPlayerIsGoalie25(false)
		}
		if (!playerIsGoalie25) {
			setPlayerIsGoalie25(true)
		}
	}
	const togglePlayerIsTaxiCheckbox25 = (e) => {
		if (playerIsTaxi25) {
			setPlayerIsTaxi25(false)
		}
		if (!playerIsTaxi25) {
			setPlayerIsTaxi25(true)
		}
	}
	const togglePlayerIsActiveCheckbox25 = (e) => {
		if (playerIsActive25) {
			setPlayerIsActive25(false)
		}
		if (!playerIsActive25) {
			setPlayerIsActive25(true)
		}
	}
	//*************************************************** */
	//  Player 26
	//*************************************************** */
	const getName26 = (event) => {
		setName26(event.target.value)
	}
	const getNumber26 = (event) => {
		setNumber26(event.target.value)
	}
	const getBY26 = (event) => {
		setBY26(event.target.value)
	}
	const togglePlayerIsGoalieCheckbox26 = (e) => {
		if (playerIsGoalie26) {
			setPlayerIsGoalie26(false)
		}
		if (!playerIsGoalie26) {
			setPlayerIsGoalie26(true)
		}
	}
	const togglePlayerIsTaxiCheckbox26 = (e) => {
		if (playerIsTaxi26) {
			setPlayerIsTaxi26(false)
		}
		if (!playerIsTaxi26) {
			setPlayerIsTaxi26(true)
		}
	}
	const togglePlayerIsActiveCheckbox26 = (e) => {
		if (playerIsActive26) {
			setPlayerIsActive26(false)
		}
		if (!playerIsActive26) {
			setPlayerIsActive26(true)
		}
	}
	//*************************************************** */
	//  Player 27
	//*************************************************** */
	const getName27 = (event) => {
		setName27(event.target.value)
	}
	const getNumber27 = (event) => {
		setNumber27(event.target.value)
	}
	const getBY27 = (event) => {
		setBY27(event.target.value)
	}
	const togglePlayerIsGoalieCheckbox27 = (e) => {
		if (playerIsGoalie27) {
			setPlayerIsGoalie27(false)
		}
		if (!playerIsGoalie27) {
			setPlayerIsGoalie27(true)
		}
	}
	const togglePlayerIsTaxiCheckbox27 = (e) => {
		if (playerIsTaxi27) {
			setPlayerIsTaxi27(false)
		}
		if (!playerIsTaxi27) {
			setPlayerIsTaxi27(true)
		}
	}
	const togglePlayerIsActiveCheckbox27 = (e) => {
		if (playerIsActive27) {
			setPlayerIsActive27(false)
		}
		if (!playerIsActive27) {
			setPlayerIsActive27(true)
		}
	}
	//*************************************************** */
	//  Player 28
	//*************************************************** */
	const getName28 = (event) => {
		setName28(event.target.value)
	}
	const getNumber28 = (event) => {
		setNumber28(event.target.value)
	}
	const getBY28 = (event) => {
		setBY28(event.target.value)
	}
	const togglePlayerIsGoalieCheckbox28 = (e) => {
		if (playerIsGoalie28) {
			setPlayerIsGoalie28(false)
		}
		if (!playerIsGoalie28) {
			setPlayerIsGoalie28(true)
		}
	}
	const togglePlayerIsTaxiCheckbox28 = (e) => {
		if (playerIsTaxi28) {
			setPlayerIsTaxi28(false)
		}
		if (!playerIsTaxi28) {
			setPlayerIsTaxi28(true)
		}
	}
	const togglePlayerIsActiveCheckbox28 = (e) => {
		if (playerIsActive28) {
			setPlayerIsActive28(false)
		}
		if (!playerIsActive28) {
			setPlayerIsActive28(true)
		}
	}
	//*************************************************** */
	//  Player 29
	//*************************************************** */
	const getName29 = (event) => {
		setName29(event.target.value)
	}
	const getNumber29 = (event) => {
		setNumber29(event.target.value)
	}
	const getBY29 = (event) => {
		setBY29(event.target.value)
	}
	const togglePlayerIsGoalieCheckbox29 = (e) => {
		if (playerIsGoalie29) {
			setPlayerIsGoalie29(false)
		}
		if (!playerIsGoalie29) {
			setPlayerIsGoalie29(true)
		}
	}
	const togglePlayerIsTaxiCheckbox29 = (e) => {
		if (playerIsTaxi29) {
			setPlayerIsTaxi29(false)
		}
		if (!playerIsTaxi29) {
			setPlayerIsTaxi29(true)
		}
	}
	const togglePlayerIsActiveCheckbox29 = (e) => {
		if (playerIsActive29) {
			setPlayerIsActive29(false)
		}
		if (!playerIsActive29) {
			setPlayerIsActive29(true)
		}
	}
	//*************************************************** */
	//  Player 30
	//*************************************************** */
	const getName30 = (event) => {
		setName30(event.target.value)
	}
	const getNumber30 = (event) => {
		setNumber30(event.target.value)
	}
	const getBY30 = (event) => {
		setBY30(event.target.value)
	}
	const togglePlayerIsGoalieCheckbox30 = (e) => {
		if (playerIsGoalie30) {
			setPlayerIsGoalie30(false)
		}
		if (!playerIsGoalie30) {
			setPlayerIsGoalie30(true)
		}
	}
	const togglePlayerIsTaxiCheckbox30 = (e) => {
		if (playerIsTaxi30) {
			setPlayerIsTaxi30(false)
		}
		if (!playerIsTaxi30) {
			setPlayerIsTaxi30(true)
		}
	}
	const togglePlayerIsActiveCheckbox30 = (e) => {
		if (playerIsActive30) {
			setPlayerIsActive30(false)
		}
		if (!playerIsActive30) {
			setPlayerIsActive30(true)
		}
	}
	//
	const getHoodie1 = (e) => setHoodie1(e.target.value)
	const getHoodie2 = (e) => setHoodie2(e.target.value)
	const getHoodie3 = (e) => setHoodie3(e.target.value)
	const getHoodie4 = (e) => setHoodie4(e.target.value)
	const getHoodie5 = (e) => setHoodie5(e.target.value)
	const getHoodie6 = (e) => setHoodie6(e.target.value)
	const getHoodie7 = (e) => setHoodie7(e.target.value)
	const getHoodie8 = (e) => setHoodie8(e.target.value)
	const getHoodie9 = (e) => setHoodie9(e.target.value)
	const getHoodie10 = (e) => setHoodie10(e.target.value)

	const getHoodie11 = (e) => setHoodie11(e.target.value)
	const getHoodie12 = (e) => setHoodie12(e.target.value)
	const getHoodie13 = (e) => setHoodie13(e.target.value)
	const getHoodie14 = (e) => setHoodie14(e.target.value)
	const getHoodie15 = (e) => setHoodie15(e.target.value)
	const getHoodie16 = (e) => setHoodie16(e.target.value)
	const getHoodie17 = (e) => setHoodie17(e.target.value)
	const getHoodie18 = (e) => setHoodie18(e.target.value)
	const getHoodie19 = (e) => setHoodie19(e.target.value)
	const getHoodie20 = (e) => setHoodie20(e.target.value)

	const getHoodie21 = (e) => setHoodie21(e.target.value)
	const getHoodie22 = (e) => setHoodie22(e.target.value)
	const getHoodie23 = (e) => setHoodie23(e.target.value)
	const getHoodie24 = (e) => setHoodie24(e.target.value)
	const getHoodie25 = (e) => setHoodie25(e.target.value)
	const getHoodie26 = (e) => setHoodie26(e.target.value)
	const getHoodie27 = (e) => setHoodie27(e.target.value)
	const getHoodie28 = (e) => setHoodie28(e.target.value)
	const getHoodie29 = (e) => setHoodie29(e.target.value)
	const getHoodie30 = (e) => setHoodie30(e.target.value)
	//
	const getTeeShirt1 = (e) => setTeeShirt1(e.target.value)
	const getTeeShirt2 = (e) => setTeeShirt2(e.target.value)
	const getTeeShirt3 = (e) => setTeeShirt3(e.target.value)
	const getTeeShirt4 = (e) => setTeeShirt4(e.target.value)
	const getTeeShirt5 = (e) => setTeeShirt5(e.target.value)
	const getTeeShirt6 = (e) => setTeeShirt6(e.target.value)
	const getTeeShirt7 = (e) => setTeeShirt7(e.target.value)
	const getTeeShirt8 = (e) => setTeeShirt8(e.target.value)
	const getTeeShirt9 = (e) => setTeeShirt9(e.target.value)
	const getTeeShirt10 = (e) => setTeeShirt10(e.target.value)

	const getTeeShirt11 = (e) => setTeeShirt11(e.target.value)
	const getTeeShirt12 = (e) => setTeeShirt12(e.target.value)
	const getTeeShirt13 = (e) => setTeeShirt13(e.target.value)
	const getTeeShirt14 = (e) => setTeeShirt14(e.target.value)
	const getTeeShirt15 = (e) => setTeeShirt15(e.target.value)
	const getTeeShirt16 = (e) => setTeeShirt16(e.target.value)
	const getTeeShirt17 = (e) => setTeeShirt17(e.target.value)
	const getTeeShirt18 = (e) => setTeeShirt18(e.target.value)
	const getTeeShirt19 = (e) => setTeeShirt19(e.target.value)
	const getTeeShirt20 = (e) => setTeeShirt20(e.target.value)

	const getTeeShirt21 = (e) => setTeeShirt21(e.target.value)
	const getTeeShirt22 = (e) => setTeeShirt22(e.target.value)
	const getTeeShirt23 = (e) => setTeeShirt23(e.target.value)
	const getTeeShirt24 = (e) => setTeeShirt24(e.target.value)
	const getTeeShirt25 = (e) => setTeeShirt25(e.target.value)
	const getTeeShirt26 = (e) => setTeeShirt26(e.target.value)
	const getTeeShirt27 = (e) => setTeeShirt27(e.target.value)
	const getTeeShirt28 = (e) => setTeeShirt28(e.target.value)
	const getTeeShirt29 = (e) => setTeeShirt29(e.target.value)
	const getTeeShirt30 = (e) => setTeeShirt30(e.target.value)

	//
	//
	let navigate = useNavigate()
	//
	//
	//Lets go into the database and update this team
	//
	//admin-controller      editRegisteredTeam
	//
	const registerUpdateHandler = async (event) => {
		let headCoachOut,
			assistantCoachesOut,
			shipToNameOut,
			shippingAddressOut,
			teamOut,
			orgOut,
			manualOrgOut,
			divOut,
			abcOut,
			yearOut,
			dateOut,
			name1Out,
			number1Out,
			BY1Out,
			name2Out,
			number2Out,
			BY2Out,
			name3Out,
			number3Out,
			BY3Out,
			name4Out,
			number4Out,
			BY4Out,
			name5Out,
			number5Out,
			BY5Out,
			name6Out,
			number6Out,
			BY6Out,
			name7Out,
			number7Out,
			BY7Out,
			name8Out,
			number8Out,
			BY8Out,
			name9Out,
			number9Out,
			BY9Out,
			name10Out,
			number10Out,
			BY10Out,
			name11Out,
			number11Out,
			BY11Out,
			name12Out,
			number12Out,
			BY12Out,
			name13Out,
			number13Out,
			BY13Out,
			name14Out,
			number14Out,
			BY14Out,
			name15Out,
			number15Out,
			BY15Out,
			name16Out,
			number16Out,
			BY16Out,
			name17Out,
			number17Out,
			BY17Out,
			name18Out,
			number18Out,
			BY18Out,
			name19Out,
			number19Out,
			BY19Out,
			name20Out,
			number20Out,
			BY20Out,
			name21Out,
			number21Out,
			BY21Out,
			name22Out,
			number22Out,
			BY22Out,
			name23Out,
			number23Out,
			BY23Out,
			name24Out,
			number24Out,
			BY24Out,
			name25Out,
			number25Out,
			BY25Out,
			name26Out,
			number26Out,
			BY26Out,
			name27Out,
			number27Out,
			BY27Out,
			name28Out,
			number28Out,
			BY28Out,
			name29Out,
			number29Out,
			BY29Out,
			name30Out,
			number30Out,
			BY30Out
		//
		//
		if (!headCoach) {
			headCoachOut = originalHeadCoach
		} else {
			headCoachOut = headCoach
		}
		if (!assistantCoaches) {
			assistantCoachesOut = originalAssistantCoaches
		} else {
			assistantCoachesOut = assistantCoaches
		}
		//
		if (!shipToName) {
			shipToNameOut = originalShipToName
		} else {
			shipToNameOut = shipToName
		}
		//
		if (!shippingAddress) {
			shippingAddressOut = originalShippingAddress
		} else {
			shippingAddressOut = shippingAddress
		}
		//
		if (!team) {
			teamOut = originalTeam
		} else {
			teamOut = team
		}
		//
		//
		if (!org) {
			orgOut = originalOrg
		} else {
			orgOut = org
		}
		//
		if (
			(orgOut === 'Non PABHA Pennsylvania Team' ||
				orgOut === 'Out of State Teams') &&
			manualOrg.trim()
		) {
			manualOrgOut = manualOrg.trim()
		} else {
			manualOrgOut = ''
		}
		//
		if (!div) {
			divOut = originalDiv
		} else {
			divOut = div
		}
		//
		if (!abc) {
			abcOut = originalAbc
		} else {
			abcOut = abc
		}
		//
		//
		if (!year) {
			yearOut = originalYear
		} else {
			yearOut = year
		}
		if (!date) {
			dateOut = originalDate
		} else {
			dateOut = date
		}
		//
		//
		// ***************************************************************
		// PLAYER NAMES
		// Use changed state if the user edited the field.
		// Otherwise keep the original database value.
		// ***************************************************************

		name1Out = name1 ?? originalName1 ?? ''
		name2Out = name2 ?? originalName2 ?? ''
		name3Out = name3 ?? originalName3 ?? ''
		name4Out = name4 ?? originalName4 ?? ''
		name5Out = name5 ?? originalName5 ?? ''
		name6Out = name6 ?? originalName6 ?? ''
		name7Out = name7 ?? originalName7 ?? ''
		name8Out = name8 ?? originalName8 ?? ''
		name9Out = name9 ?? originalName9 ?? ''
		name10Out = name10 ?? originalName10 ?? ''
		name11Out = name11 ?? originalName11 ?? ''
		name12Out = name12 ?? originalName12 ?? ''
		name13Out = name13 ?? originalName13 ?? ''
		name14Out = name14 ?? originalName14 ?? ''
		name15Out = name15 ?? originalName15 ?? ''
		name16Out = name16 ?? originalName16 ?? ''
		name17Out = name17 ?? originalName17 ?? ''
		name18Out = name18 ?? originalName18 ?? ''
		name19Out = name19 ?? originalName19 ?? ''
		name20Out = name20 ?? originalName20 ?? ''
		name21Out = name21 ?? originalName21 ?? ''
		name22Out = name22 ?? originalName22 ?? ''
		name23Out = name23 ?? originalName23 ?? ''
		name24Out = name24 ?? originalName24 ?? ''
		name25Out = name25 ?? originalName25 ?? ''
		name26Out = name26 ?? originalName26 ?? ''
		name27Out = name27 ?? originalName27 ?? ''
		name28Out = name28 ?? originalName28 ?? ''
		name29Out = name29 ?? originalName29 ?? ''
		name30Out = name30 ?? originalName30 ?? ''

		// ***************************************************************
		// PLAYER NUMBERS
		// ***************************************************************

		number1Out = number1 ?? originalNumber1 ?? ''
		number2Out = number2 ?? originalNumber2 ?? ''
		number3Out = number3 ?? originalNumber3 ?? ''
		number4Out = number4 ?? originalNumber4 ?? ''
		number5Out = number5 ?? originalNumber5 ?? ''
		number6Out = number6 ?? originalNumber6 ?? ''
		number7Out = number7 ?? originalNumber7 ?? ''
		number8Out = number8 ?? originalNumber8 ?? ''
		number9Out = number9 ?? originalNumber9 ?? ''
		number10Out = number10 ?? originalNumber10 ?? ''
		number11Out = number11 ?? originalNumber11 ?? ''
		number12Out = number12 ?? originalNumber12 ?? ''
		number13Out = number13 ?? originalNumber13 ?? ''
		number14Out = number14 ?? originalNumber14 ?? ''
		number15Out = number15 ?? originalNumber15 ?? ''
		number16Out = number16 ?? originalNumber16 ?? ''
		number17Out = number17 ?? originalNumber17 ?? ''
		number18Out = number18 ?? originalNumber18 ?? ''
		number19Out = number19 ?? originalNumber19 ?? ''
		number20Out = number20 ?? originalNumber20 ?? ''
		number21Out = number21 ?? originalNumber21 ?? ''
		number22Out = number22 ?? originalNumber22 ?? ''
		number23Out = number23 ?? originalNumber23 ?? ''
		number24Out = number24 ?? originalNumber24 ?? ''
		number25Out = number25 ?? originalNumber25 ?? ''
		number26Out = number26 ?? originalNumber26 ?? ''
		number27Out = number27 ?? originalNumber27 ?? ''
		number28Out = number28 ?? originalNumber28 ?? ''
		number29Out = number29 ?? originalNumber29 ?? ''
		number30Out = number30 ?? originalNumber30 ?? ''

		// ***************************************************************
		// PLAYER BIRTH YEARS
		// ***************************************************************

		BY1Out = BY1 ?? originalBY1 ?? ''
		BY2Out = BY2 ?? originalBY2 ?? ''
		BY3Out = BY3 ?? originalBY3 ?? ''
		BY4Out = BY4 ?? originalBY4 ?? ''
		BY5Out = BY5 ?? originalBY5 ?? ''
		BY6Out = BY6 ?? originalBY6 ?? ''
		BY7Out = BY7 ?? originalBY7 ?? ''
		BY8Out = BY8 ?? originalBY8 ?? ''
		BY9Out = BY9 ?? originalBY9 ?? ''
		BY10Out = BY10 ?? originalBY10 ?? ''
		BY11Out = BY11 ?? originalBY11 ?? ''
		BY12Out = BY12 ?? originalBY12 ?? ''
		BY13Out = BY13 ?? originalBY13 ?? ''
		BY14Out = BY14 ?? originalBY14 ?? ''
		BY15Out = BY15 ?? originalBY15 ?? ''
		BY16Out = BY16 ?? originalBY16 ?? ''
		BY17Out = BY17 ?? originalBY17 ?? ''
		BY18Out = BY18 ?? originalBY18 ?? ''
		BY19Out = BY19 ?? originalBY19 ?? ''
		BY20Out = BY20 ?? originalBY20 ?? ''
		BY21Out = BY21 ?? originalBY21 ?? ''
		BY22Out = BY22 ?? originalBY22 ?? ''
		BY23Out = BY23 ?? originalBY23 ?? ''
		BY24Out = BY24 ?? originalBY24 ?? ''
		BY25Out = BY25 ?? originalBY25 ?? ''
		BY26Out = BY26 ?? originalBY26 ?? ''
		BY27Out = BY27 ?? originalBY27 ?? ''
		BY28Out = BY28 ?? originalBY28 ?? ''
		BY29Out = BY29 ?? originalBY29 ?? ''
		BY30Out = BY30 ?? originalBY30 ?? ''
		//
		const teeShirt1Out = document.getElementById('tee1').value
		const hoodie1Out = document.getElementById('hoodie1').value

		const teeShirt2Out = document.getElementById('tee2').value
		const hoodie2Out = document.getElementById('hoodie2').value

		const teeShirt3Out = document.getElementById('tee3').value
		const hoodie3Out = document.getElementById('hoodie3').value

		const teeShirt4Out = document.getElementById('tee4').value
		const hoodie4Out = document.getElementById('hoodie4').value

		const teeShirt5Out = document.getElementById('tee5').value
		const hoodie5Out = document.getElementById('hoodie5').value

		const teeShirt6Out = document.getElementById('tee6').value
		const hoodie6Out = document.getElementById('hoodie6').value

		const teeShirt7Out = document.getElementById('tee7').value
		const hoodie7Out = document.getElementById('hoodie7').value

		const teeShirt8Out = document.getElementById('tee8').value
		const hoodie8Out = document.getElementById('hoodie8').value

		const teeShirt9Out = document.getElementById('tee9').value
		const hoodie9Out = document.getElementById('hoodie9').value

		const teeShirt10Out = document.getElementById('tee10').value
		const hoodie10Out = document.getElementById('hoodie10').value

		const teeShirt11Out = document.getElementById('tee11').value
		const hoodie11Out = document.getElementById('hoodie11').value

		const teeShirt12Out = document.getElementById('tee12').value
		const hoodie12Out = document.getElementById('hoodie12').value

		const teeShirt13Out = document.getElementById('tee13').value
		const hoodie13Out = document.getElementById('hoodie13').value

		const teeShirt14Out = document.getElementById('tee14').value
		const hoodie14Out = document.getElementById('hoodie14').value

		const teeShirt15Out = document.getElementById('tee15').value
		const hoodie15Out = document.getElementById('hoodie15').value

		const teeShirt16Out = document.getElementById('tee16').value
		const hoodie16Out = document.getElementById('hoodie16').value

		const teeShirt17Out = document.getElementById('tee17').value
		const hoodie17Out = document.getElementById('hoodie17').value

		const teeShirt18Out = document.getElementById('tee18').value
		const hoodie18Out = document.getElementById('hoodie18').value

		const teeShirt19Out = document.getElementById('tee19').value
		const hoodie19Out = document.getElementById('hoodie19').value

		const teeShirt20Out = document.getElementById('tee20').value
		const hoodie20Out = document.getElementById('hoodie20').value

		const teeShirt21Out = document.getElementById('tee21').value
		const hoodie21Out = document.getElementById('hoodie21').value

		const teeShirt22Out = document.getElementById('tee22').value
		const hoodie22Out = document.getElementById('hoodie22').value

		const teeShirt23Out = document.getElementById('tee23').value
		const hoodie23Out = document.getElementById('hoodie23').value

		const teeShirt24Out = document.getElementById('tee24').value
		const hoodie24Out = document.getElementById('hoodie24').value

		const teeShirt25Out = document.getElementById('tee25').value
		const hoodie25Out = document.getElementById('hoodie25').value

		const teeShirt26Out = document.getElementById('tee26').value
		const hoodie26Out = document.getElementById('hoodie26').value

		const teeShirt27Out = document.getElementById('tee27').value
		const hoodie27Out = document.getElementById('hoodie27').value

		const teeShirt28Out = document.getElementById('tee28').value
		const hoodie28Out = document.getElementById('hoodie28').value

		const teeShirt29Out = document.getElementById('tee29').value
		const hoodie29Out = document.getElementById('hoodie29').value

		const teeShirt30Out = document.getElementById('tee30').value
		const hoodie30Out = document.getElementById('hoodie30').value

		//
		//
		//admin-controller     editRegisteredTeam
		console.log('you are here 1')
		event.preventDefault()

		setFormSubmitted(true)

		if (showManualOrgInput && manualOrg.trim() === '') {
			setManualOrgTouched(true)
			return
		}

		try {
			setIsLoading(true)

			let url

			if (registeredTeamId) {
				url =
					process.env.REACT_APP_BACKEND_URL +
					`/admin/updateRegisteredTeamById/${registeredTeamId}`
			} else if (orgId) {
				url =
					process.env.REACT_APP_BACKEND_URL +
					`/admin/updateRegisteredTeam/org/${orgId}/${encodeURIComponent(
						inputTeamName,
					)}/${inputYear}`
			} else {
				url =
					process.env.REACT_APP_BACKEND_URL +
					`/admin/updateRegisteredTeam/${coachId}/${encodeURIComponent(
						inputTeamName,
					)}/${inputYear}`
			}

			const response = await fetch(
				url,
				/* process.env.REACT_APP_BACKEND_URL +
					`/admin/updateRegisteredTeam/${coachId}/${inputTeamName}/${inputYear}`, */
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${
							auth.isLoggedIn ? auth.token : auth.coachToken
						}`,
					},
					body: JSON.stringify({
						headCoachOut,
						assistantCoachesOut,
						shipToNameOut,
						shippingAddressOut,
						teamOut,
						orgOut,
						manualOrgOut,
						divOut,
						abcOut,
						yearOut,
						dateOut,
						name1Out,
						number1Out,
						BY1Out,
						playerIsGoalie1,
						playerIsTaxi1,
						name2Out,
						number2Out,
						BY2Out,
						playerIsGoalie2,
						playerIsTaxi2,
						name3Out,
						number3Out,
						BY3Out,
						playerIsGoalie3,
						playerIsTaxi3,
						name4Out,
						number4Out,
						BY4Out,
						playerIsGoalie4,
						playerIsTaxi4,
						name5Out,
						number5Out,
						BY5Out,
						playerIsGoalie5,
						playerIsTaxi5,
						name6Out,
						number6Out,
						BY6Out,
						playerIsGoalie6,
						playerIsTaxi6,
						name7Out,
						number7Out,
						BY7Out,
						playerIsGoalie7,
						playerIsTaxi7,
						name8Out,
						number8Out,
						BY8Out,
						playerIsGoalie8,
						playerIsTaxi8,
						name9Out,
						number9Out,
						BY9Out,
						playerIsGoalie9,
						playerIsTaxi9,
						name10Out,
						number10Out,
						BY10Out,
						playerIsGoalie10,
						playerIsTaxi10,
						name11Out,
						number11Out,
						BY11Out,
						playerIsGoalie11,
						playerIsTaxi11,
						name12Out,
						number12Out,
						BY12Out,
						playerIsGoalie12,
						playerIsTaxi12,
						name13Out,
						number13Out,
						BY13Out,
						playerIsGoalie13,
						playerIsTaxi13,
						name14Out,
						number14Out,
						BY14Out,
						playerIsGoalie14,
						playerIsTaxi14,
						name15Out,
						number15Out,
						BY15Out,
						playerIsGoalie15,
						playerIsTaxi15,
						name16Out,
						number16Out,
						BY16Out,
						playerIsGoalie16,
						playerIsTaxi16,
						name17Out,
						number17Out,
						BY17Out,
						playerIsGoalie17,
						playerIsTaxi17,
						name18Out,
						number18Out,
						BY18Out,
						playerIsGoalie18,
						playerIsTaxi18,
						name19Out,
						number19Out,
						BY19Out,
						playerIsGoalie19,
						playerIsTaxi19,
						name20Out,
						number20Out,
						BY20Out,
						playerIsGoalie20,
						playerIsTaxi20,
						name21Out,
						number21Out,
						BY21Out,
						playerIsGoalie21,
						playerIsTaxi21,
						name22Out,
						number22Out,
						BY22Out,
						playerIsGoalie22,
						playerIsTaxi22,
						name23Out,
						number23Out,
						BY23Out,
						playerIsGoalie23,
						playerIsTaxi23,
						name24Out,
						number24Out,
						BY24Out,
						playerIsGoalie24,
						playerIsTaxi24,
						name25Out,
						number25Out,
						BY25Out,
						playerIsGoalie25,
						playerIsTaxi25,
						name26Out,
						number26Out,
						BY26Out,
						playerIsGoalie26,
						playerIsTaxi26,
						name27Out,
						number27Out,
						BY27Out,
						playerIsGoalie27,
						playerIsTaxi27,
						name28Out,
						number28Out,
						BY28Out,
						playerIsGoalie28,
						playerIsTaxi28,
						name29Out,
						number29Out,
						BY29Out,
						playerIsGoalie29,
						playerIsTaxi29,
						name30Out,
						number30Out,
						BY30Out,
						playerIsGoalie30,
						playerIsTaxi30,
						playerIsActive1,
						playerIsActive2,
						playerIsActive3,
						playerIsActive4,
						playerIsActive5,
						playerIsActive6,
						playerIsActive7,
						playerIsActive8,
						playerIsActive9,
						playerIsActive10,
						playerIsActive11,
						playerIsActive12,
						playerIsActive13,
						playerIsActive14,
						playerIsActive15,
						playerIsActive16,
						playerIsActive17,
						playerIsActive18,
						playerIsActive19,
						playerIsActive20,
						playerIsActive21,
						playerIsActive22,
						playerIsActive23,
						playerIsActive24,
						playerIsActive25,
						playerIsActive26,
						playerIsActive27,
						playerIsActive28,
						playerIsActive29,
						playerIsActive30,
						teeShirt1Out,
						hoodie1Out,
						teeShirt2Out,
						hoodie2Out,
						teeShirt3Out,
						hoodie3Out,
						teeShirt4Out,
						hoodie4Out,
						teeShirt5Out,
						hoodie5Out,
						teeShirt6Out,
						hoodie6Out,
						teeShirt7Out,
						hoodie7Out,
						teeShirt8Out,
						hoodie8Out,
						teeShirt9Out,
						hoodie9Out,
						teeShirt10Out,
						hoodie10Out,
						teeShirt11Out,
						hoodie11Out,
						teeShirt12Out,
						hoodie12Out,
						teeShirt13Out,
						hoodie13Out,
						teeShirt14Out,
						hoodie14Out,
						teeShirt15Out,
						hoodie15Out,
						teeShirt16Out,
						hoodie16Out,
						teeShirt17Out,
						hoodie17Out,
						teeShirt18Out,
						hoodie18Out,
						teeShirt19Out,
						hoodie19Out,
						teeShirt20Out,
						hoodie20Out,
						teeShirt21Out,
						hoodie21Out,
						teeShirt22Out,
						hoodie22Out,
						teeShirt23Out,
						hoodie23Out,
						teeShirt24Out,
						hoodie24Out,
						teeShirt25Out,
						hoodie25Out,
						teeShirt26Out,
						hoodie26Out,
						teeShirt27Out,
						hoodie27Out,
						teeShirt28Out,
						hoodie28Out,
						teeShirt29Out,
						hoodie29Out,
						teeShirt30Out,
						hoodie30Out,
					}),
				},
			)
			const responseData = await response.json()
			if (!response.ok) {
				throw new Error('ERROR: ' + responseData.message)
			}

			console.log('you are here, lets show the modal')
			showSuccessfulRegistrationHandler()
		} catch (err) {
			console.log('error: ' + err)
			setIsLoading(false)
			setError(err.message + ': Something went wrong with registering a team.')
		}
	}
	//
	//
	//
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	//When user clicks OKAY on the popup modal (popup that says their confirmation was successful)
	//all this does is A: close the popup, and B: go back to the home page
	const okHandler = () => {
		console.log('ok has been clicked')
		setShowSuccessfulRegistrationModal(null)
		// setShowEditTeamModal(null)
		//navigate(`/teamRegistration/${coachId}`)
		if (orgId) {
			navigate(`/teamRegistration/org/${orgId}`)
		} else {
			navigate(`/teamRegistration/${coachId}`)
		}
	}
	//
	//
	//
	const showSuccessfulRegistrationHandler = () => {
		console.log('inside showSuccessfulRegistrationHandler')
		setShowSuccessfulRegistrationModal(true)
	}
	//
	//
	const selectedOrgForDisplay = org || originalOrg

	const showManualOrgInput =
		selectedOrgForDisplay === 'Non PABHA Pennsylvania Team' ||
		selectedOrgForDisplay === 'Out of State Teams'

	const manualOrgError =
		showManualOrgInput &&
		(manualOrgTouched || formSubmitted) &&
		manualOrg.trim() === ''
	//
	//
	return (
		<React.Fragment>
			<Modal
				show={showSuccessfulRegistrationModal}
				header='Thank You!'
				footerClass='place-item__modal-actions'
				footer={
					<React.Fragment>
						<p className='modalText'>
							Your team has successfully been edited. Thanks!
						</p>
						<br></br>
						<button
							className='okButton buttonButton'
							inverse
							onClick={okHandler}
						>
							OKAY
						</button>
					</React.Fragment>
				}
			></Modal>
			<ErrorModal error={error} onClear={errorHandler} />
			<div>
				{isLoading && <LoadingSpinner asOverlay />}
				{!isLoading && loadedOrgs && (
					<main>
						<h2>Edit Your Team</h2>
						{/* {allTeamsForACoach && allTeamsForACoach.length === 0 && ( */}
						<div className='rcard'>
							<div className='rcard-body rcard-padding'>
								<form
									className='register-form'
									onSubmit={registerUpdateHandler}
								>
									<div className='row'>
										<h1 style={{ marginBottom: '1.5rem', color: 'red' }}>
											Team Information:
										</h1>
										{/* //
									//
									//          Organization dropdown
									//
									//
									// */}
										<div className='row align-items-center mb-3'>
											<div className='col-12 col-sm-auto'>
												<label
													htmlFor='selectOrg'
													className='mb-1 mb-sm-0'
													style={{ fontWeight: 'bold' }}
												>
													Choose your organization:
												</label>
											</div>
											<div className='col-12 col-sm-auto'>
												<select
													id='selectOrg'
													className='my-1 mr-sm-2 selectOrgDivAbcDropdown'
													onChange={getOrg}
												>
													<option defaultValue>
														{originalOrg && originalOrg.toUpperCase()}
													</option>
													{orgArray.map((org, i) => (
														<option value={i} key={i}>
															{org.toUpperCase()}
														</option>
													))}
												</select>
											</div>
										</div>
										{/* //
									//
									//          Manual orginization enter.  This is for when org = Non PABHA or OUT OF STATE
									//
									//
									// */}
										{showManualOrgInput && (
											<div className='row mb-3'>
												<div className='col-sm-12 col-lg-6'>
													<div className='form-group fg-line net'>
														<label
															htmlFor='txtManualOrg'
															style={{ fontWeight: 'bold' }}
														>
															Enter your organization:
														</label>

														<input
															name='manualOrg'
															type='text'
															id='txtManualOrg'
															className='rform-control'
															placeholder='Type your organization name'
															value={manualOrg}
															onChange={getManualOrg}
															onBlur={() => setManualOrgTouched(true)}
															style={{
																border: manualOrgError ? '2px solid red' : '',
															}}
														/>

														{manualOrgError && (
															<p style={{ color: 'red', marginTop: '0.25rem' }}>
																Please enter your organization
															</p>
														)}
													</div>
												</div>
											</div>
										)}
										{/* //
									//
									//          Division dropdown
									//
									//
									// */}
										{/* DIVISION */}
										<div className='row align-items-center mb-3'>
											<div className='col-12 col-sm-auto'>
												<label
													htmlFor='selectDiv'
													className='mb-1 mb-sm-0'
													style={{ fontWeight: 'bold' }}
												>
													Division:
												</label>
											</div>

											<div className='col-12 col-sm-auto'>
												{auth.isLoggedIn ? (
													<select
														id='selectDiv'
														className='my-1 mr-sm-2 selectOrgDivAbcDropdown'
														onChange={getDiv}
													>
														<option defaultValue>
															{originalDiv && originalDiv}
														</option>

														<option value='Chipmunk'>Chipmunk</option>
														<option value='Penguin'>Penguin</option>
														<option value='Beaver'>Beaver</option>
														<option value='Cadet'>Cadet</option>
														<option value='Freshmen'>Freshmen</option>
														<option value='other'>Other</option>
													</select>
												) : (
													<div
														style={{
															fontWeight: 'bold',
															padding: '0.4rem 0',
														}}
													>
														{originalDiv}
													</div>
												)}
											</div>
										</div>
										{/* //
									//
									//          Bracket dropdown
									//
									//
									// */}
										{/* BRACKET */}
										<div className='row align-items-center mb-3'>
											<div className='col-12 col-sm-auto'>
												<label
													htmlFor='selectAbc'
													className='mb-1 mb-sm-0'
													style={{ fontWeight: 'bold' }}
												>
													Bracket:
												</label>
											</div>

											<div className='col-12 col-sm-auto'>
												{auth.isLoggedIn ? (
													<select
														id='selectAbc'
														className='my-1 mr-sm-2 selectOrgDivAbcDropdown'
														onChange={getAbc}
													>
														<option defaultValue>
															{originalAbc && originalAbc}
														</option>

														<option value='A'>A</option>
														<option value='B'>B</option>
														<option value='C'>C</option>
													</select>
												) : (
													<div
														style={{
															fontWeight: 'bold',
															padding: '0.4rem 0',
														}}
													>
														{originalAbc}
													</div>
												)}
											</div>
										</div>
										<div className='row'>
											<div className='col-sm-4'>
												<div
													className='form-group fg-line net'
													style={{ marginBottom: '2rem' }}
												>
													<label
														htmlFor='txtHeadCoach'
														style={{ fontWeight: 'bold' }}
													>
														Head Coach <span className='c-red'>*</span>
													</label>
													<input
														name='ctl00$cphBody$txtHeadCoach'
														type='text'
														id='txtHeadCoach'
														tabIndex='6'
														className='rform-control'
														//placeholder='Head Coach'
														defaultValue={originalHeadCoach}
														onChange={getHeadCoach}
														required
													/>
												</div>
											</div>
										</div>
										<div className='row'>
											<div className='col-sm-12'>
												<div
													className='form-group fg-line net'
													style={{ marginBottom: '2rem' }}
												>
													<label
														htmlFor='txtAssistantCoaches'
														style={{ fontWeight: 'bold' }}
													>
														Assistant Coach(es):{' '}
														<span className='c-red'>*</span>
													</label>
													<input
														name='ctl00$cphBody$txtAssistantCoaches'
														type='text'
														id='txtAssistantCoaches'
														tabIndex='7'
														className='rform-control'
														onChange={getAssistantCoaches}
														defaultValue={originalAssistantCoaches}
														required
													/>
												</div>
											</div>
										</div>
									</div>
									<div className='row'>
										<div className='col-sm-12 col-lg-6'>
											<div
												className='form-group fg-line net'
												style={{ marginBottom: '2rem' }}
											>
												<label htmlFor='year' style={{ fontWeight: 'bold' }}>
													Tournament Year: <span className='c-red'>*</span>
												</label>
												<select
													id='year'
													type='text'
													tabIndex='9'
													className='rform-control'
													defaultValue={originalYear}
													onChange={getYear}
													required
												>
													<option value='2026'>2026</option>
													<option value='2027'>2027</option>
													<option value='2028'>2028</option>
													<option value='2029'>2029</option>
													<option value='2030'>2030</option>
													<option value='2031'>2031</option>
													<option value='2032'>2032</option>
													<option value='2033'>2033</option>
													<option value='2034'>2034</option>
													<option value='2035'>2035</option>
													<option value='2036'>2036</option>
													<option value='2037'>2037</option>
													<option value='2038'>2038</option>
												</select>
											</div>
										</div>
									</div>
									{/* //
									//
									//    Shipping Info
									//
									// */}
									<div className='row'>
										<h1 style={{ marginBottom: '1.5rem', color: 'red' }}>
											Shipping Information:
										</h1>
										<div style={{ textAlign: 'center' }}>
											<p className='note' style={{ fontWeight: 'bold' }}>
												Enter name and address for where you'd like tournament
												prizes to be shipped.
											</p>
										</div>
										<div className='row'>
											<div className='col-sm-12'>
												<div
													className='form-group fg-line net'
													style={{ marginBottom: '2rem' }}
												>
													<label
														htmlFor='txtShipToName'
														style={{ fontWeight: 'bold' }}
													>
														Ship to Name:
													</label>
													<input
														name='ctl00$cphBody$txtShipToName'
														type='text'
														id='txtShipToName'
														tabIndex='10'
														className='rform-control'
														onChange={getShipToName}
														defaultValue={originalShipToName}
													/>
												</div>
											</div>
										</div>
										<div className='row'>
											<div className='col-sm-12'>
												<div
													className='form-group fg-line net'
													style={{ marginBottom: '2rem' }}
												>
													<label
														htmlFor='txtShippingAddress'
														style={{ fontWeight: 'bold' }}
													>
														Shipping Address:{' '}
													</label>
													<input
														name='ctl00$cphBody$txtShippingAddress'
														type='text'
														id='txtShippingAddress'
														tabIndex='11'
														className='rform-control'
														onChange={getShippingAddress}
														defaultValue={originalShippingAddress}
													/>
												</div>
											</div>
										</div>
									</div>
									{/* //
									//
									//    Rostered Players
									//
									// */}
									<div className='row justify-content-center'>
										<div className='rosteredPlayersTable'>
											<div
												className='form-group fg-line net'
												style={{ marginBottom: '2rem' }}
											>
												<h1
													htmlFor='txtPlayers'
													style={{ marginBottom: '1.5rem', color: 'red' }}
												>
													Rostered Players:
												</h1>
												<div style={{ textAlign: 'center' }}>
													<p className='note' style={{ fontWeight: 'bold' }}>
														G: Goalie | T: Taxi | A: Active
													</p>
												</div>
												<table className='roster-form desktopRosterForm'>
													<thead className='tableHeader2'>
														<tr>
															<th>Name</th>
															<th>#</th>
															<th>Birth Year</th>
															<th>G</th>
															<th>T</th>
															<th>A</th>
															<th>Tee</th>
															<th>Hoodie</th>
														</tr>
													</thead>
													<tbody>
														<tr>
															<td>
																<input
																	id='playerName1'
																	type='text'
																	defaultValue={originalName1}
																	onChange={getName1}
																/>
															</td>
															<td>
																<input
																	id='playerNumber1'
																	type='text'
																	size='3'
																	min='0'
																	max='99'
																	defaultValue={originalNumber1}
																	onChange={getNumber1}
																/>
															</td>
															<td>
																<input
																	id='playerBY1'
																	type='text'
																	size='4'
																	defaultValue={originalBY1}
																	onChange={getBY1}
																/>
															</td>
															<td>
																<input
																	id='goalie1'
																	type='checkbox'
																	checked={playerIsGoalie1}
																	onChange={togglePlayerIsGoalieCheckbox1}
																/>
															</td>
															<td>
																<input
																	id='taxi1'
																	type='checkbox'
																	checked={playerIsTaxi1}
																	onChange={togglePlayerIsTaxiCheckbox1}
																/>
															</td>
															<td>
																<input
																	id='active1'
																	type='checkbox'
																	checked={playerIsActive1}
																	onChange={togglePlayerIsActiveCheckbox1}
																/>
															</td>
															<td>
																<select
																	id='tee1'
																	//defaultValue={originalTeeShirt1 || ''}
																	value={teeShirt1 ?? originalTeeShirt1 ?? ''}
																	onChange={getTeeShirt1}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
															<td>
																<select
																	id='hoodie1'
																	//defaultValue={originalHoodie1 || ''}
																	value={hoodie1 ?? originalHoodie1 ?? ''}
																	onChange={getHoodie1}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
														</tr>

														<tr>
															<td>
																<input
																	id='playerName2'
																	type='text'
																	defaultValue={originalName2}
																	onChange={getName2}
																/>
															</td>
															<td>
																<input
																	id='playerNumber2'
																	type='text'
																	size='3'
																	min='0'
																	max='99'
																	defaultValue={originalNumber2}
																	onChange={getNumber2}
																/>
															</td>
															<td>
																<input
																	id='playerBY2'
																	type='text'
																	size='4'
																	defaultValue={originalBY2}
																	onChange={getBY2}
																/>
															</td>
															<td>
																<input
																	id='goalie2'
																	type='checkbox'
																	checked={playerIsGoalie2}
																	onChange={togglePlayerIsGoalieCheckbox2}
																/>
															</td>
															<td>
																<input
																	id='taxi2'
																	type='checkbox'
																	checked={playerIsTaxi2}
																	onChange={togglePlayerIsTaxiCheckbox2}
																/>
															</td>
															<td>
																<input
																	id='active2'
																	type='checkbox'
																	checked={playerIsActive2}
																	onChange={togglePlayerIsActiveCheckbox2}
																/>
															</td>
															<td>
																<select
																	id='tee2'
																	value={teeShirt2 ?? originalTeeShirt2 ?? ''}
																	onChange={getTeeShirt2}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
															<td>
																<select
																	id='hoodie2'
																	value={hoodie2 ?? originalHoodie2 ?? ''}
																	onChange={getHoodie2}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
														</tr>

														<tr>
															<td>
																<input
																	id='playerName3'
																	type='text'
																	defaultValue={originalName3}
																	onChange={getName3}
																/>
															</td>
															<td>
																<input
																	id='playerNumber3'
																	type='text'
																	size='3'
																	min='0'
																	max='99'
																	defaultValue={originalNumber3}
																	onChange={getNumber3}
																/>
															</td>
															<td>
																<input
																	id='playerBY3'
																	type='text'
																	size='4'
																	defaultValue={originalBY3}
																	onChange={getBY3}
																/>
															</td>
															<td>
																<input
																	id='goalie3'
																	type='checkbox'
																	checked={playerIsGoalie3}
																	onChange={togglePlayerIsGoalieCheckbox3}
																/>
															</td>
															<td>
																<input
																	id='taxi3'
																	type='checkbox'
																	checked={playerIsTaxi3}
																	onChange={togglePlayerIsTaxiCheckbox3}
																/>
															</td>
															<td>
																<input
																	id='active3'
																	type='checkbox'
																	checked={playerIsActive3}
																	onChange={togglePlayerIsActiveCheckbox3}
																/>
															</td>
															<td>
																<select
																	id='tee3'
																	value={teeShirt3 ?? originalTeeShirt3 ?? ''}
																	onChange={getTeeShirt3}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
															<td>
																<select
																	id='hoodie3'
																	value={hoodie3 ?? originalHoodie3 ?? ''}
																	onChange={getHoodie3}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
														</tr>

														<tr>
															<td>
																<input
																	id='playerName4'
																	type='text'
																	defaultValue={originalName4}
																	onChange={getName4}
																/>
															</td>
															<td>
																<input
																	id='playerNumber4'
																	type='text'
																	size='3'
																	min='0'
																	max='99'
																	defaultValue={originalNumber4}
																	onChange={getNumber4}
																/>
															</td>
															<td>
																<input
																	id='playerBY4'
																	type='text'
																	size='4'
																	defaultValue={originalBY4}
																	onChange={getBY4}
																/>
															</td>
															<td>
																<input
																	id='goalie4'
																	type='checkbox'
																	checked={playerIsGoalie4}
																	onChange={togglePlayerIsGoalieCheckbox4}
																/>
															</td>
															<td>
																<input
																	id='taxi4'
																	type='checkbox'
																	checked={playerIsTaxi4}
																	onChange={togglePlayerIsTaxiCheckbox4}
																/>
															</td>
															<td>
																<input
																	id='active4'
																	type='checkbox'
																	checked={playerIsActive4}
																	onChange={togglePlayerIsActiveCheckbox4}
																/>
															</td>
															<td>
																<select
																	id='tee4'
																	value={teeShirt4 ?? originalTeeShirt4 ?? ''}
																	onChange={getTeeShirt4}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
															<td>
																<select
																	id='hoodie4'
																	value={hoodie4 ?? originalHoodie4 ?? ''}
																	onChange={getHoodie4}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
														</tr>

														<tr>
															<td>
																<input
																	id='playerName5'
																	type='text'
																	defaultValue={originalName5}
																	onChange={getName5}
																/>
															</td>
															<td>
																<input
																	id='playerNumber5'
																	type='text'
																	size='3'
																	min='0'
																	max='99'
																	defaultValue={originalNumber5}
																	onChange={getNumber5}
																/>
															</td>
															<td>
																<input
																	id='playerBY5'
																	type='text'
																	size='4'
																	defaultValue={originalBY5}
																	onChange={getBY5}
																/>
															</td>
															<td>
																<input
																	id='goalie5'
																	type='checkbox'
																	checked={playerIsGoalie5}
																	onChange={togglePlayerIsGoalieCheckbox5}
																/>
															</td>
															<td>
																<input
																	id='taxi5'
																	type='checkbox'
																	checked={playerIsTaxi5}
																	onChange={togglePlayerIsTaxiCheckbox5}
																/>
															</td>
															<td>
																<input
																	id='active5'
																	type='checkbox'
																	checked={playerIsActive5}
																	onChange={togglePlayerIsActiveCheckbox5}
																/>
															</td>
															<td>
																<select
																	id='tee5'
																	value={teeShirt5 ?? originalTeeShirt5 ?? ''}
																	onChange={getTeeShirt5}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
															<td>
																<select
																	id='hoodie5'
																	value={hoodie5 ?? originalHoodie5 ?? ''}
																	onChange={getHoodie5}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
														</tr>

														<tr>
															<td>
																<input
																	id='playerName6'
																	type='text'
																	defaultValue={originalName6}
																	onChange={getName6}
																/>
															</td>
															<td>
																<input
																	id='playerNumber6'
																	type='text'
																	size='3'
																	min='0'
																	max='99'
																	defaultValue={originalNumber6}
																	onChange={getNumber6}
																/>
															</td>
															<td>
																<input
																	id='playerBY6'
																	type='text'
																	size='4'
																	defaultValue={originalBY6}
																	onChange={getBY6}
																/>
															</td>
															<td>
																<input
																	id='goalie6'
																	type='checkbox'
																	checked={playerIsGoalie6}
																	onChange={togglePlayerIsGoalieCheckbox6}
																/>
															</td>
															<td>
																<input
																	id='taxi6'
																	type='checkbox'
																	checked={playerIsTaxi6}
																	onChange={togglePlayerIsTaxiCheckbox6}
																/>
															</td>
															<td>
																<input
																	id='active6'
																	type='checkbox'
																	checked={playerIsActive6}
																	onChange={togglePlayerIsActiveCheckbox6}
																/>
															</td>
															<td>
																<select
																	id='tee6'
																	value={teeShirt6 ?? originalTeeShirt6 ?? ''}
																	onChange={getTeeShirt6}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
															<td>
																<select
																	id='hoodie6'
																	value={hoodie6 ?? originalHoodie6 ?? ''}
																	onChange={getHoodie6}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
														</tr>

														<tr>
															<td>
																<input
																	id='playerName7'
																	type='text'
																	defaultValue={originalName7}
																	onChange={getName7}
																/>
															</td>
															<td>
																<input
																	id='playerNumber7'
																	type='text'
																	size='3'
																	min='0'
																	max='99'
																	defaultValue={originalNumber7}
																	onChange={getNumber7}
																/>
															</td>
															<td>
																<input
																	id='playerBY7'
																	type='text'
																	size='4'
																	defaultValue={originalBY7}
																	onChange={getBY7}
																/>
															</td>
															<td>
																<input
																	id='goalie7'
																	type='checkbox'
																	checked={playerIsGoalie7}
																	onChange={togglePlayerIsGoalieCheckbox7}
																/>
															</td>
															<td>
																<input
																	id='taxi7'
																	type='checkbox'
																	checked={playerIsTaxi7}
																	onChange={togglePlayerIsTaxiCheckbox7}
																/>
															</td>
															<td>
																<input
																	id='active7'
																	type='checkbox'
																	checked={playerIsActive7}
																	onChange={togglePlayerIsActiveCheckbox7}
																/>
															</td>
															<td>
																<select
																	id='tee7'
																	value={teeShirt7 ?? originalTeeShirt7 ?? ''}
																	onChange={getTeeShirt7}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
															<td>
																<select
																	id='hoodie7'
																	value={hoodie7 ?? originalHoodie7 ?? ''}
																	onChange={getHoodie7}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
														</tr>

														<tr>
															<td>
																<input
																	id='playerName8'
																	type='text'
																	defaultValue={originalName8}
																	onChange={getName8}
																/>
															</td>
															<td>
																<input
																	id='playerNumber8'
																	type='text'
																	size='3'
																	min='0'
																	max='99'
																	defaultValue={originalNumber8}
																	onChange={getNumber8}
																/>
															</td>
															<td>
																<input
																	id='playerBY8'
																	type='text'
																	size='4'
																	defaultValue={originalBY8}
																	onChange={getBY8}
																/>
															</td>
															<td>
																<input
																	id='goalie8'
																	type='checkbox'
																	checked={playerIsGoalie8}
																	onChange={togglePlayerIsGoalieCheckbox8}
																/>
															</td>
															<td>
																<input
																	id='taxi8'
																	type='checkbox'
																	checked={playerIsTaxi8}
																	onChange={togglePlayerIsTaxiCheckbox8}
																/>
															</td>
															<td>
																<input
																	id='active8'
																	type='checkbox'
																	checked={playerIsActive8}
																	onChange={togglePlayerIsActiveCheckbox8}
																/>
															</td>
															<td>
																<select
																	id='tee8'
																	value={teeShirt8 ?? originalTeeShirt8 ?? ''}
																	onChange={getTeeShirt8}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
															<td>
																<select
																	id='hoodie8'
																	value={hoodie8 ?? originalHoodie8 ?? ''}
																	onChange={getHoodie8}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
														</tr>

														<tr>
															<td>
																<input
																	id='playerName9'
																	type='text'
																	defaultValue={originalName9}
																	onChange={getName9}
																/>
															</td>
															<td>
																<input
																	id='playerNumber9'
																	type='text'
																	size='3'
																	min='0'
																	max='99'
																	defaultValue={originalNumber9}
																	onChange={getNumber9}
																/>
															</td>
															<td>
																<input
																	id='playerBY9'
																	type='text'
																	size='4'
																	defaultValue={originalBY9}
																	onChange={getBY9}
																/>
															</td>
															<td>
																<input
																	id='goalie9'
																	type='checkbox'
																	checked={playerIsGoalie9}
																	onChange={togglePlayerIsGoalieCheckbox9}
																/>
															</td>
															<td>
																<input
																	id='taxi9'
																	type='checkbox'
																	checked={playerIsTaxi9}
																	onChange={togglePlayerIsTaxiCheckbox9}
																/>
															</td>
															<td>
																<input
																	id='active9'
																	type='checkbox'
																	checked={playerIsActive9}
																	onChange={togglePlayerIsActiveCheckbox9}
																/>
															</td>
															<td>
																<select
																	id='tee9'
																	value={teeShirt9 ?? originalTeeShirt9 ?? ''}
																	onChange={getTeeShirt9}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
															<td>
																<select
																	id='hoodie9'
																	value={hoodie9 ?? originalHoodie9 ?? ''}
																	onChange={getHoodie9}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
														</tr>

														<tr>
															<td>
																<input
																	id='playerName10'
																	type='text'
																	defaultValue={originalName10}
																	onChange={getName10}
																/>
															</td>
															<td>
																<input
																	id='playerNumber10'
																	type='text'
																	size='3'
																	min='0'
																	max='99'
																	defaultValue={originalNumber10}
																	onChange={getNumber10}
																/>
															</td>
															<td>
																<input
																	id='playerBY10'
																	type='text'
																	size='4'
																	defaultValue={originalBY10}
																	onChange={getBY10}
																/>
															</td>
															<td>
																<input
																	id='goalie10'
																	type='checkbox'
																	checked={playerIsGoalie10}
																	onChange={togglePlayerIsGoalieCheckbox10}
																/>
															</td>
															<td>
																<input
																	id='taxi10'
																	type='checkbox'
																	checked={playerIsTaxi10}
																	onChange={togglePlayerIsTaxiCheckbox10}
																/>
															</td>
															<td>
																<input
																	id='active10'
																	type='checkbox'
																	checked={playerIsActive10}
																	onChange={togglePlayerIsActiveCheckbox10}
																/>
															</td>
															<td>
																<select
																	id='tee10'
																	value={teeShirt10 ?? originalTeeShirt10 ?? ''}
																	onChange={getTeeShirt10}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
															<td>
																<select
																	id='hoodie10'
																	value={hoodie10 ?? originalHoodie10 ?? ''}
																	onChange={getHoodie10}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
														</tr>

														<tr>
															<td>
																<input
																	id='playerName11'
																	type='text'
																	defaultValue={originalName11}
																	onChange={getName11}
																/>
															</td>
															<td>
																<input
																	id='playerNumber11'
																	type='text'
																	size='3'
																	min='0'
																	max='99'
																	defaultValue={originalNumber11}
																	onChange={getNumber11}
																/>
															</td>
															<td>
																<input
																	id='playerBY11'
																	type='text'
																	size='4'
																	defaultValue={originalBY11}
																	onChange={getBY11}
																/>
															</td>
															<td>
																<input
																	id='goalie11'
																	type='checkbox'
																	checked={playerIsGoalie11}
																	onChange={togglePlayerIsGoalieCheckbox11}
																/>
															</td>
															<td>
																<input
																	id='taxi11'
																	type='checkbox'
																	checked={playerIsTaxi11}
																	onChange={togglePlayerIsTaxiCheckbox11}
																/>
															</td>
															<td>
																<input
																	id='active11'
																	type='checkbox'
																	checked={playerIsActive11}
																	onChange={togglePlayerIsActiveCheckbox11}
																/>
															</td>
															<td>
																<select
																	id='tee11'
																	value={teeShirt11 ?? originalTeeShirt11 ?? ''}
																	onChange={getTeeShirt11}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
															<td>
																<select
																	id='hoodie11'
																	value={hoodie11 ?? originalHoodie11 ?? ''}
																	onChange={getHoodie11}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
														</tr>

														<tr>
															<td>
																<input
																	id='playerName12'
																	type='text'
																	defaultValue={originalName12}
																	onChange={getName12}
																/>
															</td>
															<td>
																<input
																	id='playerNumber12'
																	type='text'
																	size='3'
																	min='0'
																	max='99'
																	defaultValue={originalNumber12}
																	onChange={getNumber12}
																/>
															</td>
															<td>
																<input
																	id='playerBY12'
																	type='text'
																	size='4'
																	defaultValue={originalBY12}
																	onChange={getBY12}
																/>
															</td>
															<td>
																<input
																	id='goalie12'
																	type='checkbox'
																	checked={playerIsGoalie12}
																	onChange={togglePlayerIsGoalieCheckbox12}
																/>
															</td>
															<td>
																<input
																	id='taxi12'
																	type='checkbox'
																	checked={playerIsTaxi12}
																	onChange={togglePlayerIsTaxiCheckbox12}
																/>
															</td>
															<td>
																<input
																	id='active12'
																	type='checkbox'
																	checked={playerIsActive12}
																	onChange={togglePlayerIsActiveCheckbox12}
																/>
															</td>
															<td>
																<select
																	id='tee12'
																	value={teeShirt12 ?? originalTeeShirt12 ?? ''}
																	onChange={getTeeShirt12}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
															<td>
																<select
																	id='hoodie12'
																	value={hoodie12 ?? originalHoodie12 ?? ''}
																	onChange={getHoodie12}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
														</tr>

														<tr>
															<td>
																<input
																	id='playerName13'
																	type='text'
																	defaultValue={originalName13}
																	onChange={getName13}
																/>
															</td>
															<td>
																<input
																	id='playerNumber13'
																	type='text'
																	size='3'
																	min='0'
																	max='99'
																	defaultValue={originalNumber13}
																	onChange={getNumber13}
																/>
															</td>
															<td>
																<input
																	id='playerBY13'
																	type='text'
																	size='4'
																	defaultValue={originalBY13}
																	onChange={getBY13}
																/>
															</td>
															<td>
																<input
																	id='goalie13'
																	type='checkbox'
																	checked={playerIsGoalie13}
																	onChange={togglePlayerIsGoalieCheckbox13}
																/>
															</td>
															<td>
																<input
																	id='taxi13'
																	type='checkbox'
																	checked={playerIsTaxi13}
																	onChange={togglePlayerIsTaxiCheckbox13}
																/>
															</td>
															<td>
																<input
																	id='active13'
																	type='checkbox'
																	checked={playerIsActive13}
																	onChange={togglePlayerIsActiveCheckbox13}
																/>
															</td>
															<td>
																<select
																	id='tee13'
																	value={teeShirt13 ?? originalTeeShirt13 ?? ''}
																	onChange={getTeeShirt13}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
															<td>
																<select
																	id='hoodie13'
																	value={hoodie13 ?? originalHoodie13 ?? ''}
																	onChange={getHoodie13}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
														</tr>

														<tr>
															<td>
																<input
																	id='playerName14'
																	type='text'
																	defaultValue={originalName14}
																	onChange={getName14}
																/>
															</td>
															<td>
																<input
																	id='playerNumber14'
																	type='text'
																	size='3'
																	min='0'
																	max='99'
																	defaultValue={originalNumber14}
																	onChange={getNumber14}
																/>
															</td>
															<td>
																<input
																	id='playerBY14'
																	type='text'
																	size='4'
																	defaultValue={originalBY14}
																	onChange={getBY14}
																/>
															</td>
															<td>
																<input
																	id='goalie14'
																	type='checkbox'
																	checked={playerIsGoalie14}
																	onChange={togglePlayerIsGoalieCheckbox14}
																/>
															</td>
															<td>
																<input
																	id='taxi14'
																	type='checkbox'
																	checked={playerIsTaxi14}
																	onChange={togglePlayerIsTaxiCheckbox14}
																/>
															</td>
															<td>
																<input
																	id='active14'
																	type='checkbox'
																	checked={playerIsActive14}
																	onChange={togglePlayerIsActiveCheckbox14}
																/>
															</td>
															<td>
																<select
																	id='tee14'
																	value={teeShirt14 ?? originalTeeShirt14 ?? ''}
																	onChange={getTeeShirt14}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
															<td>
																<select
																	id='hoodie14'
																	value={hoodie14 ?? originalHoodie14 ?? ''}
																	onChange={getHoodie14}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
														</tr>

														<tr>
															<td>
																<input
																	id='playerName15'
																	type='text'
																	defaultValue={originalName15}
																	onChange={getName15}
																/>
															</td>
															<td>
																<input
																	id='playerNumber15'
																	type='text'
																	size='3'
																	min='0'
																	max='99'
																	defaultValue={originalNumber15}
																	onChange={getNumber15}
																/>
															</td>
															<td>
																<input
																	id='playerBY15'
																	type='text'
																	size='4'
																	defaultValue={originalBY15}
																	onChange={getBY15}
																/>
															</td>
															<td>
																<input
																	id='goalie15'
																	type='checkbox'
																	checked={playerIsGoalie15}
																	onChange={togglePlayerIsGoalieCheckbox15}
																/>
															</td>
															<td>
																<input
																	id='taxi15'
																	type='checkbox'
																	checked={playerIsTaxi15}
																	onChange={togglePlayerIsTaxiCheckbox15}
																/>
															</td>
															<td>
																<input
																	id='active15'
																	type='checkbox'
																	checked={playerIsActive15}
																	onChange={togglePlayerIsActiveCheckbox15}
																/>
															</td>
															<td>
																<select
																	id='tee15'
																	value={teeShirt15 ?? originalTeeShirt15 ?? ''}
																	onChange={getTeeShirt15}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
															<td>
																<select
																	id='hoodie15'
																	value={hoodie15 ?? originalHoodie15 ?? ''}
																	onChange={getHoodie15}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
														</tr>
													</tbody>
												</table>
												<div style={{ textAlign: 'center' }}>
													<p className='note' style={{ fontWeight: 'bold' }}>
														G: Goalie | T: Taxi | A: Active
													</p>
												</div>
												<table className='roster-form desktopRosterForm'>
													<thead className='tableHeader2'>
														<tr>
															<th>Name</th>
															<th>#</th>
															<th>Birth Year</th>
															<th>G</th>
															<th>T</th>
															<th>A</th>
															<th>Tee</th>
															<th>Hoodie</th>
														</tr>
													</thead>
													<tbody>
														<tr>
															<td>
																<input
																	id='playerName16'
																	type='text'
																	defaultValue={originalName16}
																	onChange={getName16}
																/>
															</td>
															<td>
																<input
																	id='playerNumber16'
																	type='text'
																	size='3'
																	min='0'
																	max='99'
																	defaultValue={originalNumber16}
																	onChange={getNumber16}
																/>
															</td>
															<td>
																<input
																	id='playerBY16'
																	type='text'
																	size='4'
																	defaultValue={originalBY16}
																	onChange={getBY16}
																/>
															</td>
															<td>
																<input
																	id='goalie16'
																	type='checkbox'
																	checked={playerIsGoalie16}
																	onChange={togglePlayerIsGoalieCheckbox16}
																/>
															</td>
															<td>
																<input
																	id='taxi16'
																	type='checkbox'
																	checked={playerIsTaxi16}
																	onChange={togglePlayerIsTaxiCheckbox16}
																/>
															</td>
															<td>
																<input
																	id='active16'
																	type='checkbox'
																	checked={playerIsActive16}
																	onChange={togglePlayerIsActiveCheckbox16}
																/>
															</td>
															<td>
																<select
																	id='tee16'
																	value={teeShirt16 ?? originalTeeShirt16 ?? ''}
																	onChange={getTeeShirt16}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
															<td>
																<select
																	id='hoodie16'
																	value={hoodie16 ?? originalHoodie16 ?? ''}
																	onChange={getHoodie16}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
														</tr>

														<tr>
															<td>
																<input
																	id='playerName17'
																	type='text'
																	defaultValue={originalName17}
																	onChange={getName17}
																/>
															</td>
															<td>
																<input
																	id='playerNumber17'
																	type='text'
																	size='3'
																	min='0'
																	max='99'
																	defaultValue={originalNumber17}
																	onChange={getNumber17}
																/>
															</td>
															<td>
																<input
																	id='playerBY17'
																	type='text'
																	size='4'
																	defaultValue={originalBY17}
																	onChange={getBY17}
																/>
															</td>
															<td>
																<input
																	id='goalie17'
																	type='checkbox'
																	checked={playerIsGoalie17}
																	onChange={togglePlayerIsGoalieCheckbox17}
																/>
															</td>
															<td>
																<input
																	id='taxi17'
																	type='checkbox'
																	checked={playerIsTaxi17}
																	onChange={togglePlayerIsTaxiCheckbox17}
																/>
															</td>
															<td>
																<input
																	id='active17'
																	type='checkbox'
																	checked={playerIsActive17}
																	onChange={togglePlayerIsActiveCheckbox17}
																/>
															</td>
															<td>
																<select
																	id='tee17'
																	value={teeShirt17 ?? originalTeeShirt17 ?? ''}
																	onChange={getTeeShirt17}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
															<td>
																<select
																	id='hoodie17'
																	value={hoodie17 ?? originalHoodie17 ?? ''}
																	onChange={getHoodie17}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
														</tr>

														<tr>
															<td>
																<input
																	id='playerName18'
																	type='text'
																	defaultValue={originalName18}
																	onChange={getName18}
																/>
															</td>
															<td>
																<input
																	id='playerNumber18'
																	type='text'
																	size='3'
																	min='0'
																	max='99'
																	defaultValue={originalNumber18}
																	onChange={getNumber18}
																/>
															</td>
															<td>
																<input
																	id='playerBY18'
																	type='text'
																	size='4'
																	defaultValue={originalBY18}
																	onChange={getBY18}
																/>
															</td>
															<td>
																<input
																	id='goalie18'
																	type='checkbox'
																	checked={playerIsGoalie18}
																	onChange={togglePlayerIsGoalieCheckbox18}
																/>
															</td>
															<td>
																<input
																	id='taxi18'
																	type='checkbox'
																	checked={playerIsTaxi18}
																	onChange={togglePlayerIsTaxiCheckbox18}
																/>
															</td>
															<td>
																<input
																	id='active18'
																	type='checkbox'
																	checked={playerIsActive18}
																	onChange={togglePlayerIsActiveCheckbox18}
																/>
															</td>
															<td>
																<select
																	id='tee18'
																	value={teeShirt18 ?? originalTeeShirt18 ?? ''}
																	onChange={getTeeShirt18}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
															<td>
																<select
																	id='hoodie18'
																	value={hoodie18 ?? originalHoodie18 ?? ''}
																	onChange={getHoodie18}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
														</tr>

														<tr>
															<td>
																<input
																	id='playerName19'
																	type='text'
																	defaultValue={originalName19}
																	onChange={getName19}
																/>
															</td>
															<td>
																<input
																	id='playerNumber19'
																	type='text'
																	size='3'
																	min='0'
																	max='99'
																	defaultValue={originalNumber19}
																	onChange={getNumber19}
																/>
															</td>
															<td>
																<input
																	id='playerBY19'
																	type='text'
																	size='4'
																	defaultValue={originalBY19}
																	onChange={getBY19}
																/>
															</td>
															<td>
																<input
																	id='goalie19'
																	type='checkbox'
																	checked={playerIsGoalie19}
																	onChange={togglePlayerIsGoalieCheckbox19}
																/>
															</td>
															<td>
																<input
																	id='taxi19'
																	type='checkbox'
																	checked={playerIsTaxi19}
																	onChange={togglePlayerIsTaxiCheckbox19}
																/>
															</td>
															<td>
																<input
																	id='active19'
																	type='checkbox'
																	checked={playerIsActive19}
																	onChange={togglePlayerIsActiveCheckbox19}
																/>
															</td>
															<td>
																<select
																	id='tee19'
																	value={teeShirt19 ?? originalTeeShirt19 ?? ''}
																	onChange={getTeeShirt19}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
															<td>
																<select
																	id='hoodie19'
																	value={hoodie19 ?? originalHoodie19 ?? ''}
																	onChange={getHoodie19}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
														</tr>

														<tr>
															<td>
																<input
																	id='playerName20'
																	type='text'
																	defaultValue={originalName20}
																	onChange={getName20}
																/>
															</td>
															<td>
																<input
																	id='playerNumber20'
																	type='text'
																	size='3'
																	min='0'
																	max='99'
																	defaultValue={originalNumber20}
																	onChange={getNumber20}
																/>
															</td>
															<td>
																<input
																	id='playerBY20'
																	type='text'
																	size='4'
																	defaultValue={originalBY20}
																	onChange={getBY20}
																/>
															</td>
															<td>
																<input
																	id='goalie20'
																	type='checkbox'
																	checked={playerIsGoalie20}
																	onChange={togglePlayerIsGoalieCheckbox20}
																/>
															</td>
															<td>
																<input
																	id='taxi20'
																	type='checkbox'
																	checked={playerIsTaxi20}
																	onChange={togglePlayerIsTaxiCheckbox20}
																/>
															</td>
															<td>
																<input
																	id='active20'
																	type='checkbox'
																	checked={playerIsActive20}
																	onChange={togglePlayerIsActiveCheckbox20}
																/>
															</td>
															<td>
																<select
																	id='tee20'
																	value={teeShirt20 ?? originalTeeShirt20 ?? ''}
																	onChange={getTeeShirt20}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
															<td>
																<select
																	id='hoodie20'
																	value={hoodie20 ?? originalHoodie20 ?? ''}
																	onChange={getHoodie20}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
														</tr>

														<tr>
															<td>
																<input
																	id='playerName21'
																	type='text'
																	defaultValue={originalName21}
																	onChange={getName21}
																/>
															</td>
															<td>
																<input
																	id='playerNumber21'
																	type='text'
																	size='3'
																	min='0'
																	max='99'
																	defaultValue={originalNumber21}
																	onChange={getNumber21}
																/>
															</td>
															<td>
																<input
																	id='playerBY21'
																	type='text'
																	size='4'
																	defaultValue={originalBY21}
																	onChange={getBY21}
																/>
															</td>
															<td>
																<input
																	id='goalie21'
																	type='checkbox'
																	checked={playerIsGoalie21}
																	onChange={togglePlayerIsGoalieCheckbox21}
																/>
															</td>
															<td>
																<input
																	id='taxi21'
																	type='checkbox'
																	checked={playerIsTaxi21}
																	onChange={togglePlayerIsTaxiCheckbox21}
																/>
															</td>
															<td>
																<input
																	id='active21'
																	type='checkbox'
																	checked={playerIsActive21}
																	onChange={togglePlayerIsActiveCheckbox21}
																/>
															</td>
															<td>
																<select
																	id='tee21'
																	value={teeShirt21 ?? originalTeeShirt21 ?? ''}
																	onChange={getTeeShirt21}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
															<td>
																<select
																	id='hoodie21'
																	value={hoodie21 ?? originalHoodie21 ?? ''}
																	onChange={getHoodie21}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
														</tr>

														<tr>
															<td>
																<input
																	id='playerName22'
																	type='text'
																	defaultValue={originalName22}
																	onChange={getName22}
																/>
															</td>
															<td>
																<input
																	id='playerNumber22'
																	type='text'
																	size='3'
																	min='0'
																	max='99'
																	defaultValue={originalNumber22}
																	onChange={getNumber22}
																/>
															</td>
															<td>
																<input
																	id='playerBY22'
																	type='text'
																	size='4'
																	defaultValue={originalBY22}
																	onChange={getBY22}
																/>
															</td>
															<td>
																<input
																	id='goalie22'
																	type='checkbox'
																	checked={playerIsGoalie22}
																	onChange={togglePlayerIsGoalieCheckbox22}
																/>
															</td>
															<td>
																<input
																	id='taxi22'
																	type='checkbox'
																	checked={playerIsTaxi22}
																	onChange={togglePlayerIsTaxiCheckbox22}
																/>
															</td>
															<td>
																<input
																	id='active22'
																	type='checkbox'
																	checked={playerIsActive22}
																	onChange={togglePlayerIsActiveCheckbox22}
																/>
															</td>
															<td>
																<select
																	id='tee22'
																	value={teeShirt22 ?? originalTeeShirt22 ?? ''}
																	onChange={getTeeShirt22}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
															<td>
																<select
																	id='hoodie22'
																	value={hoodie22 ?? originalHoodie22 ?? ''}
																	onChange={getHoodie22}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
														</tr>

														<tr>
															<td>
																<input
																	id='playerName23'
																	type='text'
																	defaultValue={originalName23}
																	onChange={getName23}
																/>
															</td>
															<td>
																<input
																	id='playerNumber23'
																	type='text'
																	size='3'
																	min='0'
																	max='99'
																	defaultValue={originalNumber23}
																	onChange={getNumber23}
																/>
															</td>
															<td>
																<input
																	id='playerBY23'
																	type='text'
																	size='4'
																	defaultValue={originalBY23}
																	onChange={getBY23}
																/>
															</td>
															<td>
																<input
																	id='goalie23'
																	type='checkbox'
																	checked={playerIsGoalie23}
																	onChange={togglePlayerIsGoalieCheckbox23}
																/>
															</td>
															<td>
																<input
																	id='taxi23'
																	type='checkbox'
																	checked={playerIsTaxi23}
																	onChange={togglePlayerIsTaxiCheckbox23}
																/>
															</td>
															<td>
																<input
																	id='active23'
																	type='checkbox'
																	checked={playerIsActive23}
																	onChange={togglePlayerIsActiveCheckbox23}
																/>
															</td>
															<td>
																<select
																	id='tee23'
																	value={teeShirt23 ?? originalTeeShirt23 ?? ''}
																	onChange={getTeeShirt23}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
															<td>
																<select
																	id='hoodie23'
																	value={hoodie23 ?? originalHoodie23 ?? ''}
																	onChange={getHoodie23}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
														</tr>

														<tr>
															<td>
																<input
																	id='playerName24'
																	type='text'
																	defaultValue={originalName24}
																	onChange={getName24}
																/>
															</td>
															<td>
																<input
																	id='playerNumber24'
																	type='text'
																	size='3'
																	min='0'
																	max='99'
																	defaultValue={originalNumber24}
																	onChange={getNumber24}
																/>
															</td>
															<td>
																<input
																	id='playerBY24'
																	type='text'
																	size='4'
																	defaultValue={originalBY24}
																	onChange={getBY24}
																/>
															</td>
															<td>
																<input
																	id='goalie24'
																	type='checkbox'
																	checked={playerIsGoalie24}
																	onChange={togglePlayerIsGoalieCheckbox24}
																/>
															</td>
															<td>
																<input
																	id='taxi24'
																	type='checkbox'
																	checked={playerIsTaxi24}
																	onChange={togglePlayerIsTaxiCheckbox24}
																/>
															</td>
															<td>
																<input
																	id='active24'
																	type='checkbox'
																	checked={playerIsActive24}
																	onChange={togglePlayerIsActiveCheckbox24}
																/>
															</td>
															<td>
																<select
																	id='tee24'
																	value={teeShirt24 ?? originalTeeShirt24 ?? ''}
																	onChange={getTeeShirt24}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
															<td>
																<select
																	id='hoodie24'
																	value={hoodie24 ?? originalHoodie24 ?? ''}
																	onChange={getHoodie24}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
														</tr>

														<tr>
															<td>
																<input
																	id='playerName25'
																	type='text'
																	defaultValue={originalName25}
																	onChange={getName25}
																/>
															</td>
															<td>
																<input
																	id='playerNumber25'
																	type='text'
																	size='3'
																	min='0'
																	max='99'
																	defaultValue={originalNumber25}
																	onChange={getNumber25}
																/>
															</td>
															<td>
																<input
																	id='playerBY25'
																	type='text'
																	size='4'
																	defaultValue={originalBY25}
																	onChange={getBY25}
																/>
															</td>
															<td>
																<input
																	id='goalie25'
																	type='checkbox'
																	checked={playerIsGoalie25}
																	onChange={togglePlayerIsGoalieCheckbox25}
																/>
															</td>
															<td>
																<input
																	id='taxi25'
																	type='checkbox'
																	checked={playerIsTaxi25}
																	onChange={togglePlayerIsTaxiCheckbox25}
																/>
															</td>
															<td>
																<input
																	id='active25'
																	type='checkbox'
																	checked={playerIsActive25}
																	onChange={togglePlayerIsActiveCheckbox25}
																/>
															</td>
															<td>
																<select
																	id='tee25'
																	value={teeShirt25 ?? originalTeeShirt25 ?? ''}
																	onChange={getTeeShirt25}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
															<td>
																<select
																	id='hoodie25'
																	value={hoodie25 ?? originalHoodie25 ?? ''}
																	onChange={getHoodie25}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
														</tr>

														<tr>
															<td>
																<input
																	id='playerName26'
																	type='text'
																	defaultValue={originalName26}
																	onChange={getName26}
																/>
															</td>
															<td>
																<input
																	id='playerNumber26'
																	type='text'
																	size='3'
																	min='0'
																	max='99'
																	defaultValue={originalNumber26}
																	onChange={getNumber26}
																/>
															</td>
															<td>
																<input
																	id='playerBY26'
																	type='text'
																	size='4'
																	defaultValue={originalBY26}
																	onChange={getBY26}
																/>
															</td>
															<td>
																<input
																	id='goalie26'
																	type='checkbox'
																	checked={playerIsGoalie26}
																	onChange={togglePlayerIsGoalieCheckbox26}
																/>
															</td>
															<td>
																<input
																	id='taxi26'
																	type='checkbox'
																	checked={playerIsTaxi26}
																	onChange={togglePlayerIsTaxiCheckbox26}
																/>
															</td>
															<td>
																<input
																	id='active26'
																	type='checkbox'
																	checked={playerIsActive26}
																	onChange={togglePlayerIsActiveCheckbox26}
																/>
															</td>
															<td>
																<select
																	id='tee26'
																	value={teeShirt26 ?? originalTeeShirt26 ?? ''}
																	onChange={getTeeShirt26}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
															<td>
																<select
																	id='hoodie26'
																	value={hoodie26 ?? originalHoodie26 ?? ''}
																	onChange={getHoodie26}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
														</tr>

														<tr>
															<td>
																<input
																	id='playerName27'
																	type='text'
																	defaultValue={originalName27}
																	onChange={getName27}
																/>
															</td>
															<td>
																<input
																	id='playerNumber27'
																	type='text'
																	size='3'
																	min='0'
																	max='99'
																	defaultValue={originalNumber27}
																	onChange={getNumber27}
																/>
															</td>
															<td>
																<input
																	id='playerBY27'
																	type='text'
																	size='4'
																	defaultValue={originalBY27}
																	onChange={getBY27}
																/>
															</td>
															<td>
																<input
																	id='goalie27'
																	type='checkbox'
																	checked={playerIsGoalie27}
																	onChange={togglePlayerIsGoalieCheckbox27}
																/>
															</td>
															<td>
																<input
																	id='taxi27'
																	type='checkbox'
																	checked={playerIsTaxi27}
																	onChange={togglePlayerIsTaxiCheckbox27}
																/>
															</td>
															<td>
																<input
																	id='active27'
																	type='checkbox'
																	checked={playerIsActive27}
																	onChange={togglePlayerIsActiveCheckbox27}
																/>
															</td>
															<td>
																<select
																	id='tee27'
																	value={teeShirt27 ?? originalTeeShirt27 ?? ''}
																	onChange={getTeeShirt27}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
															<td>
																<select
																	id='hoodie27'
																	value={hoodie27 ?? originalHoodie27 ?? ''}
																	onChange={getHoodie27}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
														</tr>

														<tr>
															<td>
																<input
																	id='playerName28'
																	type='text'
																	defaultValue={originalName28}
																	onChange={getName28}
																/>
															</td>
															<td>
																<input
																	id='playerNumber28'
																	type='text'
																	size='3'
																	min='0'
																	max='99'
																	defaultValue={originalNumber28}
																	onChange={getNumber28}
																/>
															</td>
															<td>
																<input
																	id='playerBY28'
																	type='text'
																	size='4'
																	defaultValue={originalBY28}
																	onChange={getBY28}
																/>
															</td>
															<td>
																<input
																	id='goalie28'
																	type='checkbox'
																	checked={playerIsGoalie28}
																	onChange={togglePlayerIsGoalieCheckbox28}
																/>
															</td>
															<td>
																<input
																	id='taxi28'
																	type='checkbox'
																	checked={playerIsTaxi28}
																	onChange={togglePlayerIsTaxiCheckbox28}
																/>
															</td>
															<td>
																<input
																	id='active28'
																	type='checkbox'
																	checked={playerIsActive28}
																	onChange={togglePlayerIsActiveCheckbox28}
																/>
															</td>
															<td>
																<select
																	id='tee28'
																	value={teeShirt28 ?? originalTeeShirt28 ?? ''}
																	onChange={getTeeShirt28}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
															<td>
																<select
																	id='hoodie28'
																	value={hoodie28 ?? originalHoodie28 ?? ''}
																	onChange={getHoodie28}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
														</tr>

														<tr>
															<td>
																<input
																	id='playerName29'
																	type='text'
																	defaultValue={originalName29}
																	onChange={getName29}
																/>
															</td>
															<td>
																<input
																	id='playerNumber29'
																	type='text'
																	size='3'
																	min='0'
																	max='99'
																	defaultValue={originalNumber29}
																	onChange={getNumber29}
																/>
															</td>
															<td>
																<input
																	id='playerBY29'
																	type='text'
																	size='4'
																	defaultValue={originalBY29}
																	onChange={getBY29}
																/>
															</td>
															<td>
																<input
																	id='goalie29'
																	type='checkbox'
																	checked={playerIsGoalie29}
																	onChange={togglePlayerIsGoalieCheckbox29}
																/>
															</td>
															<td>
																<input
																	id='taxi29'
																	type='checkbox'
																	checked={playerIsTaxi29}
																	onChange={togglePlayerIsTaxiCheckbox29}
																/>
															</td>
															<td>
																<input
																	id='active29'
																	type='checkbox'
																	checked={playerIsActive29}
																	onChange={togglePlayerIsActiveCheckbox29}
																/>
															</td>
															<td>
																<select
																	id='tee29'
																	value={teeShirt29 ?? originalTeeShirt29 ?? ''}
																	onChange={getTeeShirt29}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
															<td>
																<select
																	id='hoodie29'
																	value={hoodie29 ?? originalHoodie29 ?? ''}
																	onChange={getHoodie29}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
														</tr>

														<tr>
															<td>
																<input
																	id='playerName30'
																	type='text'
																	defaultValue={originalName30}
																	onChange={getName30}
																/>
															</td>
															<td>
																<input
																	id='playerNumber30'
																	type='text'
																	size='3'
																	min='0'
																	max='99'
																	defaultValue={originalNumber30}
																	onChange={getNumber30}
																/>
															</td>
															<td>
																<input
																	id='playerBY30'
																	type='text'
																	size='4'
																	defaultValue={originalBY30}
																	onChange={getBY30}
																/>
															</td>
															<td>
																<input
																	id='goalie30'
																	type='checkbox'
																	checked={playerIsGoalie30}
																	onChange={togglePlayerIsGoalieCheckbox30}
																/>
															</td>
															<td>
																<input
																	id='taxi30'
																	type='checkbox'
																	checked={playerIsTaxi30}
																	onChange={togglePlayerIsTaxiCheckbox30}
																/>
															</td>
															<td>
																<input
																	id='active30'
																	type='checkbox'
																	checked={playerIsActive30}
																	onChange={togglePlayerIsActiveCheckbox30}
																/>
															</td>
															<td>
																<select
																	id='tee30'
																	value={teeShirt30 ?? originalTeeShirt30 ?? ''}
																	onChange={getTeeShirt30}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
															<td>
																<select
																	id='hoodie30'
																	value={hoodie30 ?? originalHoodie30 ?? ''}
																	onChange={getHoodie30}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</td>
														</tr>
													</tbody>
												</table>
												<div className='mobileRosterCards'>
													{/* PLAYER 1 */}
													<div className='mobileRosterCard'>
														<div className='mobileRosterTopRow'>
															<div className='mobileRosterNumber'>
																<label>#</label>
																<input
																	type='text'
																	defaultValue={originalNumber1}
																	onChange={getNumber1}
																/>
															</div>

															<div className='mobileRosterName'>
																<label>Player Name</label>
																<input
																	type='text'
																	defaultValue={originalName1}
																	onChange={getName1}
																/>
															</div>
														</div>

														<div className='mobileRosterInfoRow'>
															<div>
																<label>Birth Year</label>
																<input
																	type='text'
																	defaultValue={originalBY1}
																	onChange={getBY1}
																/>
															</div>

															<div>
																<label>Tee Size</label>
																<select
																	value={teeShirt1 ?? originalTeeShirt1 ?? ''}
																	onChange={getTeeShirt1}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</div>

															<div>
																<label>Hoodie Size</label>
																<select
																	value={hoodie1 ?? originalHoodie1 ?? ''}
																	onChange={getHoodie1}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</div>
														</div>

														<div className='mobileRosterChecks'>
															<label>
																<input
																	type='checkbox'
																	checked={playerIsGoalie1}
																	onChange={togglePlayerIsGoalieCheckbox1}
																/>
																<span>G (Goalie)</span>
															</label>

															<label>
																<input
																	type='checkbox'
																	checked={playerIsTaxi1}
																	onChange={togglePlayerIsTaxiCheckbox1}
																/>
																<span>T (Taxi)</span>
															</label>

															<label>
																<input
																	type='checkbox'
																	checked={playerIsActive1}
																	onChange={togglePlayerIsActiveCheckbox1}
																/>
																<span>A (Active)</span>
															</label>
														</div>
													</div>

													{/* PLAYER 2 */}
													<div className='mobileRosterCard'>
														<div className='mobileRosterTopRow'>
															<div className='mobileRosterNumber'>
																<label>#</label>
																<input
																	type='text'
																	defaultValue={originalNumber2}
																	onChange={getNumber2}
																/>
															</div>

															<div className='mobileRosterName'>
																<label>Player Name</label>
																<input
																	type='text'
																	defaultValue={originalName2}
																	onChange={getName2}
																/>
															</div>
														</div>

														<div className='mobileRosterInfoRow'>
															<div>
																<label>Birth Year</label>
																<input
																	type='text'
																	defaultValue={originalBY2}
																	onChange={getBY2}
																/>
															</div>

															<div>
																<label>Tee Size</label>
																<select
																	value={teeShirt2 ?? originalTeeShirt2 ?? ''}
																	onChange={getTeeShirt2}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</div>

															<div>
																<label>Hoodie Size</label>
																<select
																	value={hoodie2 ?? originalHoodie2 ?? ''}
																	onChange={getHoodie2}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</div>
														</div>

														<div className='mobileRosterChecks'>
															<label>
																<input
																	type='checkbox'
																	checked={playerIsGoalie2}
																	onChange={togglePlayerIsGoalieCheckbox2}
																/>
																<span>G (Goalie)</span>
															</label>

															<label>
																<input
																	type='checkbox'
																	checked={playerIsTaxi2}
																	onChange={togglePlayerIsTaxiCheckbox2}
																/>
																<span>T (Taxi)</span>
															</label>

															<label>
																<input
																	type='checkbox'
																	checked={playerIsActive2}
																	onChange={togglePlayerIsActiveCheckbox2}
																/>
																<span>A (Active)</span>
															</label>
														</div>
													</div>

													{/* PLAYER 3 */}
													<div className='mobileRosterCard'>
														<div className='mobileRosterTopRow'>
															<div className='mobileRosterNumber'>
																<label>#</label>
																<input
																	type='text'
																	defaultValue={originalNumber3}
																	onChange={getNumber3}
																/>
															</div>

															<div className='mobileRosterName'>
																<label>Player Name</label>
																<input
																	type='text'
																	defaultValue={originalName3}
																	onChange={getName3}
																/>
															</div>
														</div>

														<div className='mobileRosterInfoRow'>
															<div>
																<label>Birth Year</label>
																<input
																	type='text'
																	defaultValue={originalBY3}
																	onChange={getBY3}
																/>
															</div>

															<div>
																<label>Tee Size</label>
																<select
																	value={teeShirt3 ?? originalTeeShirt3 ?? ''}
																	onChange={getTeeShirt3}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</div>

															<div>
																<label>Hoodie Size</label>
																<select
																	value={hoodie3 ?? originalHoodie3 ?? ''}
																	onChange={getHoodie3}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</div>
														</div>

														<div className='mobileRosterChecks'>
															<label>
																<input
																	type='checkbox'
																	checked={playerIsGoalie3}
																	onChange={togglePlayerIsGoalieCheckbox3}
																/>
																<span>G (Goalie)</span>
															</label>

															<label>
																<input
																	type='checkbox'
																	checked={playerIsTaxi3}
																	onChange={togglePlayerIsTaxiCheckbox3}
																/>
																<span>T (Taxi)</span>
															</label>

															<label>
																<input
																	type='checkbox'
																	checked={playerIsActive3}
																	onChange={togglePlayerIsActiveCheckbox3}
																/>
																<span>A (Active)</span>
															</label>
														</div>
													</div>

													{/* PLAYER 4 */}
													<div className='mobileRosterCard'>
														<div className='mobileRosterTopRow'>
															<div className='mobileRosterNumber'>
																<label>#</label>
																<input
																	type='text'
																	defaultValue={originalNumber4}
																	onChange={getNumber4}
																/>
															</div>

															<div className='mobileRosterName'>
																<label>Player Name</label>
																<input
																	type='text'
																	defaultValue={originalName4}
																	onChange={getName4}
																/>
															</div>
														</div>

														<div className='mobileRosterInfoRow'>
															<div>
																<label>Birth Year</label>
																<input
																	type='text'
																	defaultValue={originalBY4}
																	onChange={getBY4}
																/>
															</div>

															<div>
																<label>Tee Size</label>
																<select
																	value={teeShirt4 ?? originalTeeShirt4 ?? ''}
																	onChange={getTeeShirt4}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</div>

															<div>
																<label>Hoodie Size</label>
																<select
																	value={hoodie4 ?? originalHoodie4 ?? ''}
																	onChange={getHoodie4}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</div>
														</div>

														<div className='mobileRosterChecks'>
															<label>
																<input
																	type='checkbox'
																	checked={playerIsGoalie4}
																	onChange={togglePlayerIsGoalieCheckbox4}
																/>
																<span>G (Goalie)</span>
															</label>

															<label>
																<input
																	type='checkbox'
																	checked={playerIsTaxi4}
																	onChange={togglePlayerIsTaxiCheckbox4}
																/>
																<span>T (Taxi)</span>
															</label>

															<label>
																<input
																	type='checkbox'
																	checked={playerIsActive4}
																	onChange={togglePlayerIsActiveCheckbox4}
																/>
																<span>A (Active)</span>
															</label>
														</div>
													</div>

													{/* PLAYER 5 */}
													<div className='mobileRosterCard'>
														<div className='mobileRosterTopRow'>
															<div className='mobileRosterNumber'>
																<label>#</label>
																<input
																	type='text'
																	defaultValue={originalNumber5}
																	onChange={getNumber5}
																/>
															</div>

															<div className='mobileRosterName'>
																<label>Player Name</label>
																<input
																	type='text'
																	defaultValue={originalName5}
																	onChange={getName5}
																/>
															</div>
														</div>

														<div className='mobileRosterInfoRow'>
															<div>
																<label>Birth Year</label>
																<input
																	type='text'
																	defaultValue={originalBY5}
																	onChange={getBY5}
																/>
															</div>

															<div>
																<label>Tee Size</label>
																<select
																	value={teeShirt5 ?? originalTeeShirt5 ?? ''}
																	onChange={getTeeShirt5}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</div>

															<div>
																<label>Hoodie Size</label>
																<select
																	value={hoodie5 ?? originalHoodie5 ?? ''}
																	onChange={getHoodie5}
																>
																	{shirtSizeOptions.map((size) => (
																		<option key={size || 'blank'} value={size}>
																			{size}
																		</option>
																	))}
																</select>
															</div>
														</div>

														<div className='mobileRosterChecks'>
															<label>
																<input
																	type='checkbox'
																	checked={playerIsGoalie5}
																	onChange={togglePlayerIsGoalieCheckbox5}
																/>
																<span>G (Goalie)</span>
															</label>

															<label>
																<input
																	type='checkbox'
																	checked={playerIsTaxi5}
																	onChange={togglePlayerIsTaxiCheckbox5}
																/>
																<span>T (Taxi)</span>
															</label>

															<label>
																<input
																	type='checkbox'
																	checked={playerIsActive5}
																	onChange={togglePlayerIsActiveCheckbox5}
																/>
																<span>A (Active)</span>
															</label>
														</div>
													</div>

													{/* PLAYERS 6 - 30 */}
													{[
														{
															n: 6,
															number: originalNumber6,
															name: originalName6,
															by: originalBY6,
															tee: teeShirt6,
															originalTee: originalTeeShirt6,
															hoodie: hoodie6,
															originalHoodie: originalHoodie6,
															goalie: playerIsGoalie6,
															taxi: playerIsTaxi6,
															active: playerIsActive6,
															getNumber: getNumber6,
															getName: getName6,
															getBY: getBY6,
															getTee: getTeeShirt6,
															getHoodie: getHoodie6,
															toggleGoalie: togglePlayerIsGoalieCheckbox6,
															toggleTaxi: togglePlayerIsTaxiCheckbox6,
															toggleActive: togglePlayerIsActiveCheckbox6,
														},
														{
															n: 7,
															number: originalNumber7,
															name: originalName7,
															by: originalBY7,
															tee: teeShirt7,
															originalTee: originalTeeShirt7,
															hoodie: hoodie7,
															originalHoodie: originalHoodie7,
															goalie: playerIsGoalie7,
															taxi: playerIsTaxi7,
															active: playerIsActive7,
															getNumber: getNumber7,
															getName: getName7,
															getBY: getBY7,
															getTee: getTeeShirt7,
															getHoodie: getHoodie7,
															toggleGoalie: togglePlayerIsGoalieCheckbox7,
															toggleTaxi: togglePlayerIsTaxiCheckbox7,
															toggleActive: togglePlayerIsActiveCheckbox7,
														},
														{
															n: 8,
															number: originalNumber8,
															name: originalName8,
															by: originalBY8,
															tee: teeShirt8,
															originalTee: originalTeeShirt8,
															hoodie: hoodie8,
															originalHoodie: originalHoodie8,
															goalie: playerIsGoalie8,
															taxi: playerIsTaxi8,
															active: playerIsActive8,
															getNumber: getNumber8,
															getName: getName8,
															getBY: getBY8,
															getTee: getTeeShirt8,
															getHoodie: getHoodie8,
															toggleGoalie: togglePlayerIsGoalieCheckbox8,
															toggleTaxi: togglePlayerIsTaxiCheckbox8,
															toggleActive: togglePlayerIsActiveCheckbox8,
														},
														{
															n: 9,
															number: originalNumber9,
															name: originalName9,
															by: originalBY9,
															tee: teeShirt9,
															originalTee: originalTeeShirt9,
															hoodie: hoodie9,
															originalHoodie: originalHoodie9,
															goalie: playerIsGoalie9,
															taxi: playerIsTaxi9,
															active: playerIsActive9,
															getNumber: getNumber9,
															getName: getName9,
															getBY: getBY9,
															getTee: getTeeShirt9,
															getHoodie: getHoodie9,
															toggleGoalie: togglePlayerIsGoalieCheckbox9,
															toggleTaxi: togglePlayerIsTaxiCheckbox9,
															toggleActive: togglePlayerIsActiveCheckbox9,
														},
														{
															n: 10,
															number: originalNumber10,
															name: originalName10,
															by: originalBY10,
															tee: teeShirt10,
															originalTee: originalTeeShirt10,
															hoodie: hoodie10,
															originalHoodie: originalHoodie10,
															goalie: playerIsGoalie10,
															taxi: playerIsTaxi10,
															active: playerIsActive10,
															getNumber: getNumber10,
															getName: getName10,
															getBY: getBY10,
															getTee: getTeeShirt10,
															getHoodie: getHoodie10,
															toggleGoalie: togglePlayerIsGoalieCheckbox10,
															toggleTaxi: togglePlayerIsTaxiCheckbox10,
															toggleActive: togglePlayerIsActiveCheckbox10,
														},
														{
															n: 11,
															number: originalNumber11,
															name: originalName11,
															by: originalBY11,
															tee: teeShirt11,
															originalTee: originalTeeShirt11,
															hoodie: hoodie11,
															originalHoodie: originalHoodie11,
															goalie: playerIsGoalie11,
															taxi: playerIsTaxi11,
															active: playerIsActive11,
															getNumber: getNumber11,
															getName: getName11,
															getBY: getBY11,
															getTee: getTeeShirt11,
															getHoodie: getHoodie11,
															toggleGoalie: togglePlayerIsGoalieCheckbox11,
															toggleTaxi: togglePlayerIsTaxiCheckbox11,
															toggleActive: togglePlayerIsActiveCheckbox11,
														},
														{
															n: 12,
															number: originalNumber12,
															name: originalName12,
															by: originalBY12,
															tee: teeShirt12,
															originalTee: originalTeeShirt12,
															hoodie: hoodie12,
															originalHoodie: originalHoodie12,
															goalie: playerIsGoalie12,
															taxi: playerIsTaxi12,
															active: playerIsActive12,
															getNumber: getNumber12,
															getName: getName12,
															getBY: getBY12,
															getTee: getTeeShirt12,
															getHoodie: getHoodie12,
															toggleGoalie: togglePlayerIsGoalieCheckbox12,
															toggleTaxi: togglePlayerIsTaxiCheckbox12,
															toggleActive: togglePlayerIsActiveCheckbox12,
														},
														{
															n: 13,
															number: originalNumber13,
															name: originalName13,
															by: originalBY13,
															tee: teeShirt13,
															originalTee: originalTeeShirt13,
															hoodie: hoodie13,
															originalHoodie: originalHoodie13,
															goalie: playerIsGoalie13,
															taxi: playerIsTaxi13,
															active: playerIsActive13,
															getNumber: getNumber13,
															getName: getName13,
															getBY: getBY13,
															getTee: getTeeShirt13,
															getHoodie: getHoodie13,
															toggleGoalie: togglePlayerIsGoalieCheckbox13,
															toggleTaxi: togglePlayerIsTaxiCheckbox13,
															toggleActive: togglePlayerIsActiveCheckbox13,
														},
														{
															n: 14,
															number: originalNumber14,
															name: originalName14,
															by: originalBY14,
															tee: teeShirt14,
															originalTee: originalTeeShirt14,
															hoodie: hoodie14,
															originalHoodie: originalHoodie14,
															goalie: playerIsGoalie14,
															taxi: playerIsTaxi14,
															active: playerIsActive14,
															getNumber: getNumber14,
															getName: getName14,
															getBY: getBY14,
															getTee: getTeeShirt14,
															getHoodie: getHoodie14,
															toggleGoalie: togglePlayerIsGoalieCheckbox14,
															toggleTaxi: togglePlayerIsTaxiCheckbox14,
															toggleActive: togglePlayerIsActiveCheckbox14,
														},
														{
															n: 15,
															number: originalNumber15,
															name: originalName15,
															by: originalBY15,
															tee: teeShirt15,
															originalTee: originalTeeShirt15,
															hoodie: hoodie15,
															originalHoodie: originalHoodie15,
															goalie: playerIsGoalie15,
															taxi: playerIsTaxi15,
															active: playerIsActive15,
															getNumber: getNumber15,
															getName: getName15,
															getBY: getBY15,
															getTee: getTeeShirt15,
															getHoodie: getHoodie15,
															toggleGoalie: togglePlayerIsGoalieCheckbox15,
															toggleTaxi: togglePlayerIsTaxiCheckbox15,
															toggleActive: togglePlayerIsActiveCheckbox15,
														},
														{
															n: 16,
															number: originalNumber16,
															name: originalName16,
															by: originalBY16,
															tee: teeShirt16,
															originalTee: originalTeeShirt16,
															hoodie: hoodie16,
															originalHoodie: originalHoodie16,
															goalie: playerIsGoalie16,
															taxi: playerIsTaxi16,
															active: playerIsActive16,
															getNumber: getNumber16,
															getName: getName16,
															getBY: getBY16,
															getTee: getTeeShirt16,
															getHoodie: getHoodie16,
															toggleGoalie: togglePlayerIsGoalieCheckbox16,
															toggleTaxi: togglePlayerIsTaxiCheckbox16,
															toggleActive: togglePlayerIsActiveCheckbox16,
														},
														{
															n: 17,
															number: originalNumber17,
															name: originalName17,
															by: originalBY17,
															tee: teeShirt17,
															originalTee: originalTeeShirt17,
															hoodie: hoodie17,
															originalHoodie: originalHoodie17,
															goalie: playerIsGoalie17,
															taxi: playerIsTaxi17,
															active: playerIsActive17,
															getNumber: getNumber17,
															getName: getName17,
															getBY: getBY17,
															getTee: getTeeShirt17,
															getHoodie: getHoodie17,
															toggleGoalie: togglePlayerIsGoalieCheckbox17,
															toggleTaxi: togglePlayerIsTaxiCheckbox17,
															toggleActive: togglePlayerIsActiveCheckbox17,
														},
														{
															n: 18,
															number: originalNumber18,
															name: originalName18,
															by: originalBY18,
															tee: teeShirt18,
															originalTee: originalTeeShirt18,
															hoodie: hoodie18,
															originalHoodie: originalHoodie18,
															goalie: playerIsGoalie18,
															taxi: playerIsTaxi18,
															active: playerIsActive18,
															getNumber: getNumber18,
															getName: getName18,
															getBY: getBY18,
															getTee: getTeeShirt18,
															getHoodie: getHoodie18,
															toggleGoalie: togglePlayerIsGoalieCheckbox18,
															toggleTaxi: togglePlayerIsTaxiCheckbox18,
															toggleActive: togglePlayerIsActiveCheckbox18,
														},
														{
															n: 19,
															number: originalNumber19,
															name: originalName19,
															by: originalBY19,
															tee: teeShirt19,
															originalTee: originalTeeShirt19,
															hoodie: hoodie19,
															originalHoodie: originalHoodie19,
															goalie: playerIsGoalie19,
															taxi: playerIsTaxi19,
															active: playerIsActive19,
															getNumber: getNumber19,
															getName: getName19,
															getBY: getBY19,
															getTee: getTeeShirt19,
															getHoodie: getHoodie19,
															toggleGoalie: togglePlayerIsGoalieCheckbox19,
															toggleTaxi: togglePlayerIsTaxiCheckbox19,
															toggleActive: togglePlayerIsActiveCheckbox19,
														},
														{
															n: 20,
															number: originalNumber20,
															name: originalName20,
															by: originalBY20,
															tee: teeShirt20,
															originalTee: originalTeeShirt20,
															hoodie: hoodie20,
															originalHoodie: originalHoodie20,
															goalie: playerIsGoalie20,
															taxi: playerIsTaxi20,
															active: playerIsActive20,
															getNumber: getNumber20,
															getName: getName20,
															getBY: getBY20,
															getTee: getTeeShirt20,
															getHoodie: getHoodie20,
															toggleGoalie: togglePlayerIsGoalieCheckbox20,
															toggleTaxi: togglePlayerIsTaxiCheckbox20,
															toggleActive: togglePlayerIsActiveCheckbox20,
														},
														{
															n: 21,
															number: originalNumber21,
															name: originalName21,
															by: originalBY21,
															tee: teeShirt21,
															originalTee: originalTeeShirt21,
															hoodie: hoodie21,
															originalHoodie: originalHoodie21,
															goalie: playerIsGoalie21,
															taxi: playerIsTaxi21,
															active: playerIsActive21,
															getNumber: getNumber21,
															getName: getName21,
															getBY: getBY21,
															getTee: getTeeShirt21,
															getHoodie: getHoodie21,
															toggleGoalie: togglePlayerIsGoalieCheckbox21,
															toggleTaxi: togglePlayerIsTaxiCheckbox21,
															toggleActive: togglePlayerIsActiveCheckbox21,
														},
														{
															n: 22,
															number: originalNumber22,
															name: originalName22,
															by: originalBY22,
															tee: teeShirt22,
															originalTee: originalTeeShirt22,
															hoodie: hoodie22,
															originalHoodie: originalHoodie22,
															goalie: playerIsGoalie22,
															taxi: playerIsTaxi22,
															active: playerIsActive22,
															getNumber: getNumber22,
															getName: getName22,
															getBY: getBY22,
															getTee: getTeeShirt22,
															getHoodie: getHoodie22,
															toggleGoalie: togglePlayerIsGoalieCheckbox22,
															toggleTaxi: togglePlayerIsTaxiCheckbox22,
															toggleActive: togglePlayerIsActiveCheckbox22,
														},
														{
															n: 23,
															number: originalNumber23,
															name: originalName23,
															by: originalBY23,
															tee: teeShirt23,
															originalTee: originalTeeShirt23,
															hoodie: hoodie23,
															originalHoodie: originalHoodie23,
															goalie: playerIsGoalie23,
															taxi: playerIsTaxi23,
															active: playerIsActive23,
															getNumber: getNumber23,
															getName: getName23,
															getBY: getBY23,
															getTee: getTeeShirt23,
															getHoodie: getHoodie23,
															toggleGoalie: togglePlayerIsGoalieCheckbox23,
															toggleTaxi: togglePlayerIsTaxiCheckbox23,
															toggleActive: togglePlayerIsActiveCheckbox23,
														},
														{
															n: 24,
															number: originalNumber24,
															name: originalName24,
															by: originalBY24,
															tee: teeShirt24,
															originalTee: originalTeeShirt24,
															hoodie: hoodie24,
															originalHoodie: originalHoodie24,
															goalie: playerIsGoalie24,
															taxi: playerIsTaxi24,
															active: playerIsActive24,
															getNumber: getNumber24,
															getName: getName24,
															getBY: getBY24,
															getTee: getTeeShirt24,
															getHoodie: getHoodie24,
															toggleGoalie: togglePlayerIsGoalieCheckbox24,
															toggleTaxi: togglePlayerIsTaxiCheckbox24,
															toggleActive: togglePlayerIsActiveCheckbox24,
														},
														{
															n: 25,
															number: originalNumber25,
															name: originalName25,
															by: originalBY25,
															tee: teeShirt25,
															originalTee: originalTeeShirt25,
															hoodie: hoodie25,
															originalHoodie: originalHoodie25,
															goalie: playerIsGoalie25,
															taxi: playerIsTaxi25,
															active: playerIsActive25,
															getNumber: getNumber25,
															getName: getName25,
															getBY: getBY25,
															getTee: getTeeShirt25,
															getHoodie: getHoodie25,
															toggleGoalie: togglePlayerIsGoalieCheckbox25,
															toggleTaxi: togglePlayerIsTaxiCheckbox25,
															toggleActive: togglePlayerIsActiveCheckbox25,
														},
														{
															n: 26,
															number: originalNumber26,
															name: originalName26,
															by: originalBY26,
															tee: teeShirt26,
															originalTee: originalTeeShirt26,
															hoodie: hoodie26,
															originalHoodie: originalHoodie26,
															goalie: playerIsGoalie26,
															taxi: playerIsTaxi26,
															active: playerIsActive26,
															getNumber: getNumber26,
															getName: getName26,
															getBY: getBY26,
															getTee: getTeeShirt26,
															getHoodie: getHoodie26,
															toggleGoalie: togglePlayerIsGoalieCheckbox26,
															toggleTaxi: togglePlayerIsTaxiCheckbox26,
															toggleActive: togglePlayerIsActiveCheckbox26,
														},
														{
															n: 27,
															number: originalNumber27,
															name: originalName27,
															by: originalBY27,
															tee: teeShirt27,
															originalTee: originalTeeShirt27,
															hoodie: hoodie27,
															originalHoodie: originalHoodie27,
															goalie: playerIsGoalie27,
															taxi: playerIsTaxi27,
															active: playerIsActive27,
															getNumber: getNumber27,
															getName: getName27,
															getBY: getBY27,
															getTee: getTeeShirt27,
															getHoodie: getHoodie27,
															toggleGoalie: togglePlayerIsGoalieCheckbox27,
															toggleTaxi: togglePlayerIsTaxiCheckbox27,
															toggleActive: togglePlayerIsActiveCheckbox27,
														},
														{
															n: 28,
															number: originalNumber28,
															name: originalName28,
															by: originalBY28,
															tee: teeShirt28,
															originalTee: originalTeeShirt28,
															hoodie: hoodie28,
															originalHoodie: originalHoodie28,
															goalie: playerIsGoalie28,
															taxi: playerIsTaxi28,
															active: playerIsActive28,
															getNumber: getNumber28,
															getName: getName28,
															getBY: getBY28,
															getTee: getTeeShirt28,
															getHoodie: getHoodie28,
															toggleGoalie: togglePlayerIsGoalieCheckbox28,
															toggleTaxi: togglePlayerIsTaxiCheckbox28,
															toggleActive: togglePlayerIsActiveCheckbox28,
														},
														{
															n: 29,
															number: originalNumber29,
															name: originalName29,
															by: originalBY29,
															tee: teeShirt29,
															originalTee: originalTeeShirt29,
															hoodie: hoodie29,
															originalHoodie: originalHoodie29,
															goalie: playerIsGoalie29,
															taxi: playerIsTaxi29,
															active: playerIsActive29,
															getNumber: getNumber29,
															getName: getName29,
															getBY: getBY29,
															getTee: getTeeShirt29,
															getHoodie: getHoodie29,
															toggleGoalie: togglePlayerIsGoalieCheckbox29,
															toggleTaxi: togglePlayerIsTaxiCheckbox29,
															toggleActive: togglePlayerIsActiveCheckbox29,
														},
														{
															n: 30,
															number: originalNumber30,
															name: originalName30,
															by: originalBY30,
															tee: teeShirt30,
															originalTee: originalTeeShirt30,
															hoodie: hoodie30,
															originalHoodie: originalHoodie30,
															goalie: playerIsGoalie30,
															taxi: playerIsTaxi30,
															active: playerIsActive30,
															getNumber: getNumber30,
															getName: getName30,
															getBY: getBY30,
															getTee: getTeeShirt30,
															getHoodie: getHoodie30,
															toggleGoalie: togglePlayerIsGoalieCheckbox30,
															toggleTaxi: togglePlayerIsTaxiCheckbox30,
															toggleActive: togglePlayerIsActiveCheckbox30,
														},
													].map((player) => (
														<div className='mobileRosterCard' key={player.n}>
															<div className='mobileRosterTopRow'>
																<div className='mobileRosterNumber'>
																	<label>#</label>
																	<input
																		type='text'
																		defaultValue={player.number}
																		onChange={player.getNumber}
																	/>
																</div>

																<div className='mobileRosterName'>
																	<label>Player Name</label>
																	<input
																		type='text'
																		defaultValue={player.name}
																		onChange={player.getName}
																	/>
																</div>
															</div>

															<div className='mobileRosterInfoRow'>
																<div>
																	<label>Birth Year</label>
																	<input
																		type='text'
																		defaultValue={player.by}
																		onChange={player.getBY}
																	/>
																</div>

																<div>
																	<label>Tee Size</label>
																	<select
																		value={
																			player.tee ?? player.originalTee ?? ''
																		}
																		onChange={player.getTee}
																	>
																		{shirtSizeOptions.map((size) => (
																			<option
																				key={size || 'blank'}
																				value={size}
																			>
																				{size}
																			</option>
																		))}
																	</select>
																</div>

																<div>
																	<label>Hoodie Size</label>
																	<select
																		value={
																			player.hoodie ??
																			player.originalHoodie ??
																			''
																		}
																		onChange={player.getHoodie}
																	>
																		{shirtSizeOptions.map((size) => (
																			<option
																				key={size || 'blank'}
																				value={size}
																			>
																				{size}
																			</option>
																		))}
																	</select>
																</div>
															</div>

															<div className='mobileRosterChecks'>
																<label>
																	<input
																		type='checkbox'
																		checked={player.goalie}
																		onChange={player.toggleGoalie}
																	/>
																	<span>G (Goalie)</span>
																</label>

																<label>
																	<input
																		type='checkbox'
																		checked={player.taxi}
																		onChange={player.toggleTaxi}
																	/>
																	<span>T (Taxi)</span>
																</label>

																<label>
																	<input
																		type='checkbox'
																		checked={player.active}
																		onChange={player.toggleActive}
																	/>
																	<span>A (Active)</span>
																</label>
															</div>
														</div>
													))}
												</div>
											</div>
										</div>
									</div>
									{/* <div className='row'>
									<div className='col-lg-6 col-lg-3'>
										<div
											className='form-group fg-line net'
											style={{ marginBottom: '2rem' }}
										>
											<label htmlFor='txtDate' style={{ fontWeight: 'bold' }}>
												Todays Date: <span className='c-red'>*</span>
											</label>
											<input
												name='ctl00$cphBody$txtCity'
												type='date'
												id='txtDate'
												tabIndex='10'
												className='rform-control'
												placeholder='Date'
												defaultValue={originalDate}
												onChange={getDate}
												required
											/>
										</div>
									</div>
								</div> */}
									<Button type='submit'>UPDATE</Button>
								</form>
							</div>
						</div>
					</main>
				)}
			</div>
			<Footer />
		</React.Fragment>
	)
}

export default TeamRegistrationUpdate
